{
  "a11y": {
    "home": "Dubai To-Do — Startseite",
    "menu": "Menü",
    "closeMenu": "Menü schließen",
    "search": "Suche",
    "language": "Sprache: {{name}}",
    "mainNav": "Hauptmenü",
    "categories": "Kategorien",
    "open": "{{title}} öffnen",
    "breadcrumb": "Navigationspfad",
    "saved": "Gemerkt",
    "account": "Konto",
    "save": "{{title}} merken"
  },
  "nav": {
    "tours": "Touren",
    "boats": "Yachten & Boote",
    "desert": "Wüste",
    "attractions": "Sehenswürdigkeiten",
    "dayTrips": "Tagesausflüge",
    "home": "Startseite",
    "events": "Events",
    "guides": "Reiseführer",
    "hotels": "Wo übernachten"
  },
  "home": {
    "metaTitle": "Dubai Aktivitäten — Wüstensafari, Ausflüge & Dhau-Fahrten",
    "metaDescription": "Aktivitäten in Dubai, nach echten Bewertungen sortiert: Wüstensafari, Stadtrundfahrt, Dhau-Fahrt, Burj-Khalifa-Tickets, Ballonfahrt und Ausflug nach Abu Dhabi.",
    "heroTitle": "Dubai Touren & Aktivitäten",
    "heroLead": "Wüstensafaris, Dhau-Fahrten und Ballonfahrten — nach echten Bewertungen sortiert.",
    "featuredTitle": "Highlights der Woche",
    "featuredEyebrow": "Handverlesene Erlebnisse, die sich lohnen",
    "viewAllExperiences": "Alle Erlebnisse ansehen",
    "moodTitle": "Passend zu Ihrer Stimmung",
    "moodEyebrow": "Handverlesene Ideen für jeden Anlass",
    "heroAlt": "Die Skyline von Dubai bei Sonnenuntergang, von einer Terrasse am Wasser aus gesehen",
    "guideTitle": "Aktivitäten in Dubai nach Kategorie",
    "guidesTitle": "Aus unseren Dubai-Reiseführern",
    "guidesEyebrow": "Reiserouten, Reisezeit und Tipps für die Planung",
    "guideCount_one": "{{count}} Erlebnis",
    "guideCount_other": "{{count}} Erlebnisse",
    "guide": {
      "desert-safari": {
        "text": "Der Klassiker in Dubai: Dune Bashing im Geländewagen, Quad fahren und Sandboarding, ein Kamelritt und ein Barbecue im Wüstencamp. Die Abendsafari bietet Sonnenuntergang und Shows, die Morgensafari kühlere, ruhigere Dünen, die Safari mit Übernachtung eine Nacht unter Sternen.",
        "link": "Wüstensafaris ansehen"
      },
      "city-tours": {
        "text": "Eine Stadtrundfahrt durch Dubai zeigt die Highlights an einem halben oder ganzen Tag: Al Fahidi und die Gold- und Gewürzsouks, eine Abra-Fahrt über den Dubai Creek, die Jumeirah-Moschee und Fotostopps am Burj Al Arab, an der Palme und am Dubai Frame.",
        "link": "Stadtrundfahrten ansehen"
      },
      "attractions": {
        "text": "Tickets für die Aussichtsplattformen des Burj Khalifa, den Dubai Frame, das Museum of the Future, das Dubai Aquarium und die Freizeitparks — mit festem Zeitfenster und ohne lange Warteschlange.",
        "link": "Tickets ansehen"
      },
      "water-sports": {
        "text": "Mit dem Jetski vorbei am Burj Al Arab und Atlantis, Parasailing über der Marina, Flyboarding, Schnorcheln und Tauchen — Wassersport in Dubai geht fast das ganze Jahr.",
        "link": "Jetski-Touren & Wassersport ansehen"
      },
      "dhow-cruise": {
        "text": "Eine Dhau-Fahrt mit Dinner ist einer der entspanntesten Abende in Dubai: ein traditionelles Holzboot, Buffet und Live-Shows — auf dem Dubai Creek entlang der alten Souks oder in der Dubai Marina zwischen den Wolkenkratzern.",
        "link": "Dhau-Fahrten ansehen"
      },
      "family": {
        "text": "Dubai mit Kindern: Wasserparks und Freizeitparks, Aquarien, ruhige Bootsfahrten und Wüstenausflüge, die Kindern wie Erwachsenen Spaß machen.",
        "link": "Familienaktivitäten ansehen"
      },
      "day-trips": {
        "text": "Abu Dhabi liegt rund 90 Minuten entfernt — mit der Scheich-Zayid-Moschee, dem Louvre Abu Dhabi und Yas Island. Oder es geht in die Berge von Hatta oder zu den Fjorden von Musandam im Oman (Reisepass mitnehmen).",
        "link": "Abu-Dhabi-Ausflüge & Tagestouren ansehen"
      },
      "scenic-flights": {
        "text": "Dubai von oben: mit dem Heißluftballon bei Sonnenaufgang über die Wüste, oft mit Frühstück und Falkenshow, oder beim Hubschrauberrundflug über Burj Khalifa, die Palme und die Marina.",
        "link": "Rundflüge ansehen"
      }
    },
    "tipsTitle": "Gut zu wissen vor der Reise",
    "tipsEyebrow": "Ihre Tage in Dubai planen",
    "tips": {
      "season": {
        "title": "Beste Reisezeit",
        "text": "Von November bis März sind die Tage warm und sonnig, die Abende angenehm — Hochsaison für Safaris, Bootsfahrten und Strandtage. Von Juni bis September werden oft über 40 °C erreicht: Wüstenausflüge dann früh morgens oder abends planen und mittags Indoor-Attraktionen besuchen."
      },
      "customs": {
        "title": "Sitten und Kleidung",
        "text": "In Moscheen, Souks und der Altstadt sind Schultern und Knie bedeckt; Frauen tragen in der Scheich-Zayid-Moschee ein Kopftuch. Im Ramadan finden die meisten Touren statt, teils zu anderen Zeiten, und nach dem Iftar wird es abends lebendig."
      },
      "booking": {
        "title": "Buchung und Abholung",
        "text": "Beliebte Safaris, Sunset-Cruises und Zeitfenster am Burj Khalifa sind in der Hochsaison schnell ausgebucht — besser vorab buchen. Viele Erlebnisse enthalten die Abholung vom Hotel und kostenlose Stornierung bis 24 Stunden vorher; die Bedingungen stehen bei jedem Angebot."
      },
      "ranking": {
        "title": "So sortieren wir",
        "text": "Nicht nur nach Sternen: Eine 5,0 aus drei Bewertungen sagt wenig, deshalb gewichten wir jede Note mit der Zahl der Bewertungen. Die Touren stammen von Viator, die Yacht- und Bootstouren von Click&Boat; gebucht wird beim Partner, und wir erhalten eventuell eine Provision — ohne Mehrkosten für Sie."
      }
    },
    "faqTitle": "Häufige Fragen",
    "faqEyebrow": "Aktivitäten in Dubai, kurz beantwortet",
    "faq": {
      "mustDo": {
        "q": "Was sollte man beim ersten Dubai-Besuch unbedingt machen?",
        "a": "Eine Abendsafari in der Wüste, die Aussichtsplattform des Burj Khalifa, eine Dhau-Fahrt auf dem Dubai Creek oder in der Dubai Marina, ein Bummel durch die alten Souks mit einer Abra-Fahrt über den Creek und ein Tag am Strand oder auf dem Wasser vor der Palm Jumeirah. Mit einem Tag mehr lohnt sich ein Ausflug nach Abu Dhabi."
      },
      "safari": {
        "q": "Welche Wüstensafari ist die richtige?",
        "a": "Am beliebtesten ist die Abendsafari: Dune Bashing, Kamelritt, Sandboarding und ein Barbecue mit Shows im Wüstencamp. Die Morgensafari ist kürzer und kühler, die Übernachtungssafari bietet eine Nacht unter Sternen, und mit Quad oder Dune Buggy fahren Sie selbst. Mit kleinen Kindern oder Rückenproblemen wählen Sie besser eine Safari ohne Dune Bashing."
      },
      "flights": {
        "q": "Lohnt sich eine Ballonfahrt oder ein Hubschrauberrundflug in Dubai?",
        "a": "Für viele Reisende ist es der Höhepunkt der Reise. Ballone starten bei Sonnenaufgang über der Wüste, die Abholung ist daher sehr früh, noch vor der Dämmerung; meist gehört ein Frühstück im Wüstencamp dazu. Hubschrauberrundflüge dauern ab etwa 12 Minuten und führen am Burj Khalifa, am Burj Al Arab, an der Palme und an der Marina vorbei."
      },
      "advance": {
        "q": "Sollte man Touren in Dubai im Voraus buchen?",
        "a": "Ja, vor allem von November bis März und an Feiertagen, wenn beliebte Safaris, Sunset-Cruises und Zeitfenster am Burj Khalifa ausgebucht sind. Wer früh bucht, sichert sich den Preis — und viele Erlebnisse lassen sich trotzdem kostenlos stornieren."
      },
      "cancel": {
        "q": "Kann ich eine Buchung stornieren?",
        "a": "Viele Erlebnisse lassen sich bis 24 Stunden vor Beginn kostenlos stornieren. Die genauen Bedingungen hängen von der Tour ab und stehen vor der Zahlung auf der Seite des Partners."
      },
      "wear": {
        "q": "Was zieht man für Touren in Dubai an?",
        "a": "Leichte, luftige Kleidung, Hut und Sonnencreme. In Moscheen, Souks und der Altstadt sollten Schultern und Knie bedeckt sein; Frauen brauchen in der Scheich-Zayid-Moschee zusätzlich ein Kopftuch. In der Wüste sind geschlossene Schuhe besser als Sandalen, und an Winterabenden kann eine leichte Jacke nützlich sein."
      },
      "kids": {
        "q": "Ist Dubai gut für Familien mit Kindern?",
        "a": "Sehr. Wasserparks, Freizeitparks, Aquarien, ruhige Bootsfahrten und familienfreundliche Wüstenausflüge machen die Planung für jedes Alter leicht. Viele Touren haben Kinderpreise; achten Sie auf das Mindestalter, besonders bei Dune Bashing und Wassersport."
      },
      "abuDhabi": {
        "q": "Kann man Abu Dhabi als Tagesausflug ab Dubai besuchen?",
        "a": "Ja. Abu Dhabi liegt etwa 90 Minuten Fahrt entfernt. Geführte Tagesausflüge umfassen meist die Scheich-Zayid-Moschee und dazu den Louvre Abu Dhabi, den Qasr Al Watan oder die Freizeitparks auf Yas Island, mit Abholung vom Hotel in Dubai."
      },
      "newYear": {
        "q": "Was kann man an Silvester in Dubai machen?",
        "a": "Das Feuerwerk am Burj Khalifa, an der Palme oder in der Marina sehen, zu einem Gala-Dinner oder einer Beachclub-Party gehen oder Mitternacht auf einer Dhau oder Yacht erleben. Unsere Silvesterseite listet die Partys und Bootsfahrten der Saison, mit Tipps zu Straßensperren und Metro."
      },
      "booking": {
        "q": "Bucht man direkt bei Dubai To-Do?",
        "a": "Wir helfen beim Vergleichen; gebucht wird auf der Seite unseres Partners — Viator für Touren, Click&Boat für Yacht- und Bootstouren — zu dessen Bedingungen, mit dessen Zahlung und Kundenservice. Wenn Sie über unsere Links buchen, erhalten wir eventuell eine Provision, ohne Mehrkosten für Sie."
      }
    },
    "eventsTitle": "Events diese Woche",
    "eventsEyebrow": "Brunches, Comedy, Konzerte und mehr in den nächsten 7 Tagen",
    "viewAllEvents": "Alle Events ansehen",
    "nyeTitle": "Silvester in Dubai",
    "nyeEyebrow": "Partys, Gala-Dinner und Bootsfahrten am 31. Dezember",
    "nyeMore": "Silvester-Ratgeber"
  },
  "search": {
    "label": "Wonach suchen Sie?",
    "placeholder": "Wonach suchen Sie?",
    "submit": "Suchen",
    "landmark": "Dubai To-Do durchsuchen",
    "searchFor": "Nach „{{query}}“ suchen",
    "categories": "Kategorien",
    "popularTitle": "Beliebte Suchen",
    "suggestions": "Vorschläge",
    "popular": [
      {
        "label": "Burj Khalifa",
        "q": "burj khalifa"
      },
      {
        "label": "Abu Dhabi",
        "q": "abu dhabi"
      },
      {
        "label": "Heißluftballon",
        "q": "ballon"
      },
      {
        "label": "Hubschrauberflug",
        "q": "hubschrauber"
      },
      {
        "label": "Jetski",
        "q": "jetski"
      },
      {
        "label": "Quad",
        "q": "quad"
      },
      {
        "label": "Dubai Marina",
        "q": "marina"
      },
      {
        "label": "Dinner-Kreuzfahrt",
        "q": "dinner"
      },
      {
        "label": "Private Tour",
        "q": "privat"
      },
      {
        "label": "Wüstensafari",
        "q": "wüste"
      }
    ]
  },
  "strip": {
    "boats": "Yachten &\nKreuzfahrten"
  },
  "collections": {
    "desert-safari": {
      "title": "Wüstensafaris",
      "short": "Wüsten-\nsafaris",
      "intro": "Dünenfahrten im Geländewagen, Kamelritte, Sandboarding und ein Abendessen im Wüstencamp unter Sternen — der Klassiker vor den Toren der Stadt.",
      "meta": "Wüstensafari und Wüstentour in Dubai buchen: abends mit BBQ und Shows oder morgens, privat, mit Quad oder Buggy – plus Tipps zu Kleidung, Kosten und Kindern.",
      "metaFrom": "Wüstensafari Dubai ab {{price}}: abends mit BBQ und Shows oder morgens, privat, mit Quad oder Buggy – plus Tipps zu Kleidung, Kosten und Kindern.",
      "seoTitle": "Wüstensafari Dubai: Abend-, Morgen- & Übernachtungstour",
      "heading": "Wüstensafari in Dubai",
      "guideTitle": "So finden Sie die passende Wüstensafari",
      "guide": [
        {
          "h": "Abends, morgens oder mit Übernachtung?",
          "p": [
            "Die Abendsafari ist der Klassiker: Abholung am Hotel am frühen Nachmittag, Dune Bashing im Geländewagen, ein Fotostopp zum Sonnenuntergang und danach ein Wüstencamp mit Kamelritt, Sandboarding, Henna, Grillbuffet und Shows wie Tanoura- und Feuertanz. Zurück in der Stadt sind Sie meist gegen 21 Uhr.",
            "Eine Morgensafari ist kürzer, kühler und weniger voll – ideal, wenn Ihre Abende schon verplant sind: Abholung früh am Morgen, Dünen im ersten Licht, oft mit Sandboarding, Kamelritt oder Quad, und gegen Mittag sind Sie zurück. Den Sonnenaufgang über der Wüste sehen Sie bei einer frühen Morgentour oder einer Ballonfahrt, den Sonnenuntergang bei der Abendsafari. Übernachtungssafaris, bei denen Sie im Camp unter dem Sternenhimmel schlafen und in der Wüste frühstücken, gibt es nur bei wenigen Anbietern."
          ]
        },
        {
          "h": "Dune Bashing, Quads und Dune Buggys",
          "p": [
            "Beim Dune Bashing fährt ein erfahrener Fahrer den Geländewagen in hohem Tempo über die Dünen – aufregend, aber holprig. Wer lieber selbst fährt, bucht dazu eine Quad- oder Buggy-Tour in den roten Dünen von Lahbab oder eine private Safari mit eigenem Fahrzeug für die Gruppe.",
            "Ruhiger geht es im Naturschutzgebiet Al Marmoom zu: Dort stehen Wildtiere, eine Heritage-Safari im Oldtimer-Geländewagen und Falknerei im Mittelpunkt statt Adrenalin. Wer kein Dune Bashing möchte, wählt eine solche Tour oder fragt beim Anbieter nach dem Transfer direkt ins Camp; auch der Kamelritt ist ein Programmpunkt, kein Muss – Sie können ihn einfach auslassen."
          ]
        },
        {
          "h": "Was Sie mitnehmen sollten und wie Sie buchen",
          "p": [
            "Tragen Sie leichte, luftige Kleidung, die Schultern und Knie bedeckt, und geschlossene Schuhe oder Sandalen, in die ruhig Sand darf – barfuß im Sand geht auch, mittags ist er aber heiß. Denken Sie an Sonnenbrille, Sonnencreme, ein Tuch gegen Wind und Sand und eine leichte Jacke – im Winter wird es abends in der Wüste kühl.",
            "Vergleichen Sie die Leistungen: Hotelabholung, Art des Camps, Abendessen (BBQ, vegetarische Optionen), Softdrinks und Extras wie Quads. Die meisten Safaris lassen sich bis 24 Stunden vorher kostenlos stornieren, und die Liste ist nach Bewertungen sortiert – die durchweg am besten bewerteten Touren stehen oben."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wüstensafari morgens oder abends – was ist besser?",
          "a": "Die Abendsafari ist das volle Programm: Dune Bashing, Sonnenuntergang in den Dünen, dann Abendessen und Shows im Camp. Die Morgensafari ist kürzer, kühler und ruhiger, ohne Abendessen und Shows – gut mit Kindern, im Sommer und wenn Sie abends schon etwas vorhaben. Den Sonnenaufgang in der Wüste erleben Sie nur bei einer sehr frühen Morgentour oder einer Ballonfahrt."
        },
        {
          "q": "Wie lange dauert eine Abendsafari in Dubai?",
          "a": "Etwa sechs bis sieben Stunden inklusive Abholung und Rücktransfer: Abfahrt am Nachmittag, rund 30–45 Minuten Dune Bashing, Sonnenuntergang und dann der Abend im Camp mit Abendessen und Shows."
        },
        {
          "q": "Was zieht man zur Wüstensafari in Dubai an?",
          "a": "Leichte, luftige Kleidung, die Schultern und Knie bedeckt, dazu bequeme Schuhe oder Sandalen, die sandig werden dürfen. Sonnenbrille, Sonnencreme und ein Tuch gegen den Sand gehören dazu; von November bis März eine Jacke oder einen Pullover für den Abend in der Wüste."
        },
        {
          "q": "Was kostet eine Wüstensafari in Dubai?",
          "a": "Das hängt vor allem von drei Dingen ab: Gruppen- oder Privattour, Morgen- oder Abendsafari (abends ist das Abendessen inklusive) und Extras wie Quad, Buggy oder ein VIP-Camp. Jede Tour in der Liste zeigt ihren aktuellen Ab-Preis; den endgültigen Preis sehen Sie bei der Buchung auf der Partnerseite."
        },
        {
          "q": "Kann man bei der Wüstensafari selbst fahren?",
          "a": "Den Geländewagen beim Dune Bashing steuert immer ein Fahrer des Anbieters. Selbst fahren Sie bei einer Quad- oder Buggy-Tour – meist in den roten Dünen von Lahbab, nach einer Einweisung und hinter einem Guide. Das Mindestalter für Fahrer und Beifahrer steht im Angebot."
        },
        {
          "q": "Private Safari, VIP oder in der Gruppe?",
          "a": "In der Gruppe teilen Sie Geländewagen und Camp mit anderen Gästen – der Klassiker. Bei einer privaten Safari haben Sie Wagen, Fahrer und Zeitplan für sich. VIP- und Luxuspakete bieten ein ruhigeres Camp, Service am Tisch und Extras wie eine Falknershow; was enthalten ist, steht im Angebot."
        },
        {
          "q": "Wird einem beim Dune Bashing übel?",
          "a": "Empfindlichen Menschen kann es auf den Dünen schon schlecht werden. Es hilft, vorher nur leicht zu essen, vorne zu sitzen und den Fahrer zu bitten, langsamer zu fahren – oder eine Safari ohne Dune Bashing zu wählen. Toiletten gibt es im Camp und meist an einem Stopp am Rand der Wüste."
        },
        {
          "q": "Ist Dune Bashing für Kinder und Schwangere geeignet?",
          "a": "Für Schwangere, Menschen mit Rücken- oder Herzproblemen und sehr kleine Kinder wird Dune Bashing nicht empfohlen. Viele Anbieter bieten Camp und Kamelritt ohne Dünenfahrt an – wählen Sie dann eine Safari ohne Dune Bashing oder eine Wildlife-Safari."
        },
        {
          "q": "Ist eine Wüstensafari mit Kleinkind möglich?",
          "a": "Ja, mit der richtigen Tour: Eine Morgensafari oder eine Safari ohne Dune Bashing ist kurz und ruhig genug, das Camp mit Kamelen, Sand und Henna gefällt auch Kleinkindern. Bei einer Privattour bestimmen Sie das Tempo selbst und können nach einem Kindersitz fragen."
        },
        {
          "q": "Gibt es Wüstensafaris auf Deutsch?",
          "a": "Kaum: Fast alle Safaris werden von englischsprachigen Fahrern und Guides geführt, Deutsch bieten nur sehr wenige Anbieter an. Die Sprachen des Guides stehen auf der Seite der Tour unter „Treffpunkt & Abholung“. Für eine Safari braucht es aber wenig Erklärung – Dünen, Camp und Shows sprechen für sich."
        },
        {
          "q": "Wann ist die beste Reisezeit für eine Wüstensafari?",
          "a": "Von Oktober bis April, wenn die Tage warm und die Abende in der Wüste angenehm sind. Safaris gibt es das ganze Jahr, doch von Juni bis September sind nur Touren am Morgen oder Abend wirklich angenehm."
        },
        {
          "q": "Ist das Abendessen bei einer Wüstensafari inklusive?",
          "a": "Bei Abend- und Übernachtungssafaris meist ja – ein Buffet oder Grillabend im Camp mit Softdrinks, Tee und Kaffee. Prüfen Sie in den Leistungen, ob es vegetarische Gerichte und Alkohol gibt."
        },
        {
          "q": "Wo findet die Wüstensafari statt?",
          "a": "In den roten Dünen südöstlich der Stadt, meist bei Lahbab und Al Badayer, 45 Minuten bis eine Stunde Fahrt von Downtown oder der Marina; Naturschutz-Safaris fahren ins Reservat Al Marmoom. Fast alle Touren holen Sie im Hotel ab."
        }
      ]
    },
    "city-tours": {
      "title": "Stadtführungen",
      "short": "Stadt-\nführungen",
      "intro": "Geführt durch Dubai — von den Souks und Windtürmen der Altstadt bis zur Skyline von Downtown und der Palme.",
      "meta": "Geführte Stadtrundfahrten in Dubai: Al Fahidi, Gold- und Gewürzsouk, Abra-Fahrt über den Dubai Creek, Jumeirah-Moschee, Burj Khalifa, Dubai Frame und Palm.",
      "seoTitle": "Stadtrundfahrt Dubai: Altstadt, Downtown & Palm",
      "heading": "Stadtrundfahrten in Dubai",
      "guideTitle": "Dubai auf einer Stadtrundfahrt entdecken",
      "guide": [
        {
          "h": "Alt-Dubai und der Dubai Creek",
          "p": [
            "Die meisten Stadttouren beginnen dort, wo Dubai entstanden ist: im historischen Viertel Al Fahidi mit seinen Windtürmen, Häusern aus Korallenstein und kleinen Museen. Danach geht es mit einer Abra – einem traditionellen Holzwassertaxi – über den Dubai Creek zu den Gold- und Gewürzsouks von Deira.",
            "Diesen Teil der Stadt erkundet man am besten zu Fuß mit einem Guide, der vom Handel, der Perlentaucherei und dem Leben vor dem Öl erzählt."
          ]
        },
        {
          "h": "Das moderne Dubai: Downtown, Jumeirah und die Palm",
          "p": [
            "Der moderne Teil einer typischen Tour umfasst Fotostopps an der Jumeirah-Moschee, am Burj Al Arab, auf der Palm Jumeirah mit dem Atlantis, am Dubai Frame und in Downtown mit Burj Khalifa und Dubai Mall. Manche Touren schließen die Aussichtsplattform des Burj Khalifa oder eine Fahrt mit der Palm-Monorail ein.",
            "Halbtagestouren zeigen entweder die Alt- oder die Neustadt, Ganztagestouren beides – meist mit Mittagessen."
          ]
        },
        {
          "h": "Gruppe, privat oder Hop-on-Hop-off?",
          "p": [
            "Kleingruppentouren sind der einfachste Weg, die Highlights mit Guide zu sehen. Eine private Tour bestimmt Tempo und Stopps selbst – praktisch mit Kindern oder zum Fotografieren. Hop-on-Hop-off-Busse, Food-Touren und Abendtouren sind gute Alternativen für alle, die im eigenen Rhythmus unterwegs sein wollen.",
            "Bei den meisten geführten Touren ist die Hotelabholung inklusive. Die Liste ist nach Bewertungen sortiert, die meisten Touren sind bis 24 Stunden vorher kostenlos stornierbar."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie lange dauert eine Stadtrundfahrt in Dubai?",
          "a": "Halbtagestouren dauern etwa vier bis fünf Stunden und zeigen entweder Alt-Dubai oder die moderne Stadt. Ganztagestouren dauern sieben bis acht Stunden und verbinden beides, oft mit Mittagspause."
        },
        {
          "q": "Gibt es eine Kleiderordnung für Moscheen in Dubai?",
          "a": "Ja: Schultern und Knie bedeckt für alle, Frauen bedecken in der Jumeirah-Moschee oder der Großen Moschee in Abu Dhabi zudem das Haar. Touren mit Moscheebesuch weisen vorab darauf hin, manche Moscheen verleihen Abayas am Eingang."
        },
        {
          "q": "Lässt sich eine Stadtrundfahrt mit dem Burj Khalifa verbinden?",
          "a": "Ja. Manche Stadttouren enthalten ein At-the-Top-Ticket; sonst buchen Sie ein Zeitfenster-Ticket für den Burj Khalifa zum Ende der Tour – die Slots zum Sonnenuntergang sind am beliebtesten und zuerst ausgebucht."
        },
        {
          "q": "Sind Stadtrundfahrten im Sommer sinnvoll?",
          "a": "Ja, wenn Sie eine Tour im klimatisierten Fahrzeug mit kurzen Fußwegen wählen. Von Juni bis September sind Touren am Morgen oder Abend deutlich angenehmer als zur Mittagszeit."
        }
      ]
    },
    "attractions": {
      "title": "Sehenswürdigkeiten & Tickets",
      "short": "Sehens-\nwürdigkeiten",
      "intro": "Aussichtsplattformen, Freizeitparks, Aquarien und Museen — Tickets für Dubais bekannteste Ziele in einer Liste.",
      "meta": "Tickets für Dubais Top-Sehenswürdigkeiten: Burj Khalifa At the Top, Dubai Frame, Museum of the Future, Dubai Aquarium, Wasserparks und Freizeitparks.",
      "seoTitle": "Dubai Sehenswürdigkeiten: Tickets für Burj Khalifa & mehr",
      "heading": "Sehenswürdigkeiten & Tickets in Dubai",
      "guideTitle": "Tickets für Dubais Sehenswürdigkeiten buchen",
      "guide": [
        {
          "h": "Aussichtsplattformen und Wahrzeichen",
          "p": [
            "Die At-the-Top-Plattformen des Burj Khalifa auf Ebene 124 und 125 bieten den bekanntesten Ausblick der Stadt; die höhere SKY-Ebene 148 kommt mit Lounge und weniger Andrang. Der Dubai Frame blickt von einer Glasbrücke auf Alt- und Neu-Dubai, und das Museum of the Future verbindet spektakuläre Architektur mit immersiven Ausstellungen.",
            "Tickets gelten für ein Zeitfenster, und die Slots zum Sonnenuntergang am Burj Khalifa sind oft Tage vorher ausgebucht – früh buchen und etwas vor der Zeit da sein."
          ]
        },
        {
          "h": "Aquarien, Wasserparks und Freizeitparks",
          "p": [
            "Das Dubai Aquarium & Underwater Zoo in der Dubai Mall und The Lost Chambers im Atlantis sind entspannte Halbtagesausflüge mit Kindern. Für einen ganzen Tag gehören Aquaventure, der Wasserpark auf der Palm, und die Indoor-Freizeitparks zu den beliebtesten Tickets der Stadt.",
            "In den heißesten Monaten von Juni bis September sind Indoor-Attraktionen die beste Wahl."
          ]
        },
        {
          "h": "Zeit und Geld sparen",
          "p": [
            "Wer vorab bucht, sichert sich Preis und Zeitfenster und umgeht die Schlangen an den Kassen der meistbesuchten Orte. Kombitickets – etwa Burj Khalifa mit Aquarium – sind meist günstiger als Einzeltickets.",
            "Prüfen Sie bei jedem Ticket Leistungen, Altersstufen und Stornobedingungen. Die Liste ist nach Bewertungen sortiert – die durchweg am besten bewerteten Attraktionen stehen oben."
          ]
        }
      ],
      "faq": [
        {
          "q": "Sollte ich Tickets für den Burj Khalifa vorab buchen?",
          "a": "Ja. Tickets gelten für eine bestimmte Uhrzeit, und an der Kasse ist es oft teurer. Die Slots zum Sonnenuntergang sind zuerst weg, besonders von November bis März und am Wochenende."
        },
        {
          "q": "Welches Burj-Khalifa-Ticket ist das richtige?",
          "a": "At the Top (Ebene 124 und 125) reicht den meisten Besuchern. At the Top SKY (Ebene 148) kostet mehr, ist aber weniger voll und enthält eine Lounge mit Erfrischungen."
        },
        {
          "q": "Was kann man in Dubai an sehr heißen Tagen unternehmen?",
          "a": "Indoor-Attraktionen: Museum of the Future, Dubai Aquarium & Underwater Zoo, The Lost Chambers, die Indoor-Freizeitparks und die Aussichtsplattformen – alle vollständig klimatisiert."
        },
        {
          "q": "Gibt es Ermäßigungen für Kinder?",
          "a": "Die meisten Attraktionen haben Kindertickets, kleine Kinder haben oft freien Eintritt. Die Altersgrenzen sind je nach Attraktion verschieden – prüfen Sie die Bedingungen vor der Buchung."
        }
      ]
    },
    "water-sports": {
      "title": "Jetski & Wassersport",
      "short": "Wasser-\nsport",
      "intro": "Mit dem Jetski vorbei am Burj Al Arab, am Atlantis und an der Skyline der Marina — dazu Parasailing, Flyboarding und Tauchen im warmen Wasser des Golfs.",
      "meta": "Jetski in Dubai: geführte Touren zum Burj Al Arab, Atlantis und zur Palm Jumeirah, dazu Jetcar, Flyboard und Tubing – mit Tipps zu Kosten, Alter und Startpunkten.",
      "metaFrom": "Jetski in Dubai ab {{price}}: geführte Touren zum Burj Al Arab, Atlantis und zur Palm Jumeirah, dazu Jetcar, Flyboard und Tubing – mit Tipps zu Alter und Startpunkten.",
      "seoTitle": "Jetski Dubai: Jetski-Touren & Wassersport",
      "heading": "Jetski & Wassersport in Dubai",
      "guideTitle": "Wassersport in Dubai: was Sie erwartet",
      "guide": [
        {
          "h": "Jetski-Touren: Routen und Dauer",
          "p": [
            "Eine Jetski-Tour ist die beliebteste Art, Dubai vom Wasser aus zu sehen. Die Dauer bestimmt die Route: 30 Minuten reichen meist bis zum Burj Al Arab für Fotos; eine Stunde ergänzt das Atlantis The Palm und den äußeren Bogen der Palm Jumeirah; Touren von 90 Minuten bis zwei Stunden führen weiter zur Dubai Marina, nach JBR und zum Riesenrad Ain Dubai.",
            "Los geht es am Dubai Harbour und in der Marina, in Jumeirah nahe dem Burj Al Arab und auf der Palm. Viele Touren legen Fotostopps vor der Skyline ein – die Fotos macht meist der Guide."
          ]
        },
        {
          "h": "Geführt oder Miete, allein oder zu zweit",
          "p": [
            "In Dubai fährt der Jetski mit Guide: Die Gruppe folgt einem Vorfahrer an der Küste entlang, was außerhalb der markierten Mietzonen Pflicht ist. Ein Führerschein ist nicht nötig; vor dem Start gibt es eine Sicherheitseinweisung und eine Schwimmweste.",
            "Die meisten Jetskis sind für zwei Personen, Paare und Eltern mit Kind teilen sich also oft einen – der Beifahrer sitzt hinten. Fahrer müssen meist mindestens 16 Jahre alt sein; die Altersgrenzen des Veranstalters stehen im Angebot."
          ]
        },
        {
          "h": "Parasailing, Flyboarding und mehr",
          "p": [
            "Beim Parasailing schweben Sie hoch über dem Strand und der Dubai Marina, allein oder zu zweit. Beim Flyboarding und Hoverboarding hebt Sie ein Wasserstrahl über die Oberfläche – ein Instruktor ist die ganze Zeit dabei. Ein Jetcar ist ein Wasserfahrzeug im Look eines Sportwagens für bis zu vier Personen, das mit Fahrer oder nach Einweisung die gleichen Routen fährt wie die Jetskis. Bananenboot, Tubing, Wakeboarden und Stand-up-Paddling sind einfache Extras für Gruppen und Familien."
          ]
        },
        {
          "h": "Schnorcheln und Tauchen",
          "p": [
            "Der Golf ist ruhig und warm, mit Riffen und Wracks vor der Küste und klarerem Wasser an der Ostküste bei Fujairah und in Musandam. Schnuppertauchgänge eignen sich für Anfänger ohne Schein, zertifizierte Taucher buchen geführte Tauchgänge.",
            "Das Wasser bleibt auch im Winter über 20 °C und erreicht im Sommer gut 30 °C, Wassersport ist also ganzjährig möglich – im Sommer am besten früh am Morgen."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie lange dauert eine Jetski-Tour in Dubai?",
          "a": "Von 30 Minuten bis zu zwei Stunden. Eine halbe Stunde reicht für den Burj Al Arab, eine Stunde ergänzt Atlantis und die Palm, längere Touren führen bis zur Dubai Marina und zum Ain Dubai."
        },
        {
          "q": "Was kostet Jetski fahren in Dubai?",
          "a": "Der Preis richtet sich vor allem nach der Dauer: Eine halbe Stunde zum Burj Al Arab ist die günstigste Tour, zwei Stunden bis zur Marina die teuerste. Er gilt meist pro Jetski, zwei Personen teilen sich also einen Preis. Jede Tour in der Liste zeigt ihren aktuellen Ab-Preis."
        },
        {
          "q": "Können zwei Personen auf einem Jetski fahren?",
          "a": "Ja, die meisten Jetskis sind Zweisitzer: Einer fährt, der andere sitzt hinten. Ob der Preis pro Jetski oder pro Person gilt, steht im Angebot."
        },
        {
          "q": "Brauche ich in Dubai einen Führerschein für den Jetski?",
          "a": "Für eine geführte Jetski-Tour nicht: Der Anbieter gibt eine Einweisung, ein Guide führt die Fahrt. Wer allein fahren will, muss meist mindestens 16 sein; jüngere Kinder fahren mit einem Erwachsenen als Beifahrer mit."
        },
        {
          "q": "Kann man in Dubai einen Jetski mieten und allein fahren?",
          "a": "Frei fahren dürfen Sie nur in kleinen, markierten Zonen vor einigen Stränden. Entlang der Küste – zum Burj Al Arab, zum Atlantis oder zur Marina – geht es nur mit Guide, und so funktionieren die Touren hier: Sie fahren Ihren Jetski selbst, ein Vorfahrer gibt Route und Tempo vor."
        },
        {
          "q": "Wo startet man für eine Jetski-Tour zum Burj Al Arab?",
          "a": "Die kürzesten Wege haben Starts an den Stränden von Jumeirah nahe dem Burj Al Arab; Touren ab dem Dubai Harbour, der Marina oder der Palm verbinden ihn mit Atlantis, der Palm Jumeirah und der Skyline von JBR. Der Treffpunkt steht in jedem Angebot."
        },
        {
          "q": "Kann man mit dem Jetski um die Palm Jumeirah und zum Atlantis fahren?",
          "a": "Ja, auf Touren ab einer Stunde: Sie folgen dem äußeren Halbmond der Palme bis zum Atlantis The Palm, meist mit dem Burj Al Arab auf derselben Fahrt. Am schnellsten geht es ab Dubai Harbour oder von der Palme selbst."
        },
        {
          "q": "Ab welchem Alter darf man in Dubai Jetski fahren?",
          "a": "Selbst fahren ab 16 Jahren. Kinder fahren als Beifahrer hinter einem Erwachsenen mit – bei vielen Touren ab etwa 6 Jahren, bei manchen später; die Grenze des Anbieters steht im Angebot."
        },
        {
          "q": "Kann ich Wassersport machen, wenn ich nicht schwimmen kann?",
          "a": "Beim Parasailing, Jetski und Bananenboot tragen Sie immer eine Schwimmweste, gute Schwimmkenntnisse sind also nicht nötig. Für Flyboarding, Schnorcheln und Tauchen sollten Sie sich im Wasser sicher fühlen."
        },
        {
          "q": "Welche Tageszeit ist für Wassersport in Dubai am besten?",
          "a": "Der Morgen, wenn das Meer am ruhigsten und die Hitze geringer ist. Der späte Nachmittag ist schön für Fotos der Skyline, doch dann frischt oft der Wind auf."
        },
        {
          "q": "Wo starten die Wassersportangebote in Dubai?",
          "a": "Die meisten in der Dubai Marina, am JBR-Strand, in Jumeirah und auf der Palm. Prüfen Sie den Treffpunkt jeder Tour – manche schließen den Hoteltransfer ein, andere nicht."
        }
      ]
    },
    "dhow-cruise": {
      "title": "Dhau-Fahrten",
      "short": "Dhau-\nFahrten",
      "intro": "Traditionelle Holz-Dhaus auf dem Dubai Creek oder durch die Marina, meist mit Abendessen an Bord, wenn die Stadt zu leuchten beginnt.",
      "meta": "Dhau-Kreuzfahrten in Dubai: Dinner-Cruises auf dem Dubai Creek und in der Dubai Marina an Bord traditioneller Holzboote, mit Buffet, Shows und Skyline.",
      "metaFrom": "Dhau-Kreuzfahrt Dubai ab {{price}}: Dinner-Cruises auf dem Dubai Creek und in der Dubai Marina an Bord traditioneller Holzboote, mit Buffet, Shows und Skyline.",
      "seoTitle": "Dhau-Kreuzfahrt Dubai: Dinner auf Creek & Marina",
      "heading": "Dhau-Kreuzfahrten in Dubai",
      "guideTitle": "Die passende Dhau-Kreuzfahrt finden",
      "guide": [
        {
          "h": "Dubai Creek oder Dubai Marina?",
          "p": [
            "Eine Fahrt auf dem Dubai Creek führt an der Altstadt vorbei: an den Souks von Deira, den Windtürmen von Al Fahidi und den Abras, die den Creek kreuzen – das traditionellere, historische Ambiente. Eine Fahrt in der Dubai Marina gleitet zwischen beleuchteten Wolkenkratzern hindurch bis zur Palm Jumeirah – die moderne Skyline bei Nacht.",
            "Beide dauern etwa zwei Stunden. Am ersten Abend in Dubai ist die Marina spektakulärer; wer die Türme schon kennt, findet den Creek stimmungsvoller."
          ]
        },
        {
          "h": "Was eine Dinner-Cruise beinhaltet",
          "p": [
            "Die meisten Dhau-Kreuzfahrten bieten ein internationales und arabisches Buffet, Softdrinks, Wasser, Tee und Kaffee sowie Unterhaltung wie Tanoura-Tanz. Gesessen wird meist auf einem offenen Oberdeck und einem klimatisierten Unterdeck – im Winter lohnt das Oberdeck wegen der Aussicht.",
            "Manche Fahrten schließen den Hoteltransfer ein, bei anderen treffen Sie sich am Anleger. Alkohol gibt es nur auf lizenzierten Booten – prüfen Sie das, falls es Ihnen wichtig ist."
          ]
        },
        {
          "h": "Mehr als die klassische Dinner-Dhau",
          "p": [
            "Es gibt auch Dhau-Fahrten zum Sonnenuntergang, Premium-Dhaus mit weniger Gästen und Menü sowie private Dhaus für Familien, Geburtstage und Gruppen.",
            "Manche Creek-Fahrten fahren weiter in den Dubai Water Canal, durch Business Bay zur Skyline am Burj Khalifa; einige Marina-Fahrten fahren hinaus zur Palme und zum Ain Dubai. Die Route steht im Angebot."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was ist eine Dhau-Kreuzfahrt?",
          "a": "Die Dhau ist das traditionelle Holzboot des Golfs, früher für Handel und Perlentauchen. In Dubai sind die Dhaus heute schwimmende Restaurants: eine zweistündige Abendfahrt mit Dinner, Musik und den Lichtern der Stadt vom Deck aus."
        },
        {
          "q": "Wie lange dauert eine Dhau-Kreuzfahrt in Dubai?",
          "a": "Meist etwa zwei Stunden auf dem Wasser, Boarding 30 Minuten vor Abfahrt. Die meisten Dinner-Cruises starten zwischen 19:30 und 20:30 Uhr."
        },
        {
          "q": "Ist eine Dhau-Kreuzfahrt für Kinder geeignet?",
          "a": "Ja, sie ist einer der einfachsten Abende für Familien: Die Boote fahren ruhig, es gibt ein Buffet, und Kinder zahlen meist weniger. Auf dem offenen Deck kleine Kinder bitte im Blick behalten."
        },
        {
          "q": "Was zieht man zu einer Dhau-Kreuzfahrt an?",
          "a": "Smart-Casual. Im Winter eine leichte Jacke für das Oberdeck mitnehmen; im Sommer ist das Unterdeck klimatisiert."
        },
        {
          "q": "Welche Dhau-Kreuzfahrt ist die beste?",
          "a": "Das hängt davon ab, was Sie sehen möchten: die Marina für die moderne Skyline, den Creek für Alt-Dubai. Die Liste ist nach Bewertungen sortiert – die durchweg am besten bewerteten Fahrten stehen oben."
        },
        {
          "q": "Wird an Bord Alkohol ausgeschenkt?",
          "a": "Nur auf Booten mit Lizenz, und die sind selten – meist in der Marina. Die klassischen Dinner-Fahrten servieren Softdrinks, Wasser, Tee und Kaffee; wenn es Ihnen wichtig ist, prüfen Sie die Leistungen."
        },
        {
          "q": "Wie bucht man eine Dhau-Kreuzfahrt?",
          "a": "Online für Ihr Wunschdatum: Am Wochenende und in der Wintersaison sind die Dinner-Fahrten schnell voll. Wählen Sie Creek oder Marina, prüfen Sie, ob der Hoteltransfer enthalten ist, und halten Sie die Bestätigung beim Einsteigen bereit."
        }
      ]
    },
    "family": {
      "title": "Familie",
      "short": "Familie",
      "intro": "Ausflüge für Kinder und Erwachsene — Wasserparks, Aquarien, ruhige Bootsfahrten und Erlebnisse zum Mitmachen.",
      "meta": "Dubai mit Kindern: Wasser- und Freizeitparks, Aquarien, Ski Dubai, familienfreundliche Wüstensafaris und Bootsfahrten – mit Tipps zu Kleinkindern, Sommer und Silvester.",
      "seoTitle": "Dubai mit Kindern: Aktivitäten für Familien",
      "heading": "Dubai mit Kindern",
      "guideTitle": "Familienurlaub in Dubai planen",
      "guide": [
        {
          "h": "Ausflüge für jedes Alter",
          "p": [
            "Dubai gehört zu den einfachsten Reisezielen der Welt mit Kindern. Wasserparks, Aquarien und Indoor-Freizeitparks füllen ganze Tage; kürzere Ausflüge wie eine Dhau-Fahrt, eine Abra-Fahrt über den Creek oder die Aussichtsplattform des Burj Khalifa passen zwischen die Mittagsschläfchen.",
            "Für Teenager sind Jetski oder Sandboarding ein Highlight, für kleine Kinder oft eine ruhige Bootsfahrt oder das Aquarium."
          ]
        },
        {
          "h": "Familienfreundliche Wüstensafaris",
          "p": [
            "Ein Ausflug in die Wüste gehört für viele Familien dazu, sollte aber gut gewählt sein: Dune Bashing wird für sehr kleine Kinder nicht empfohlen. Suchen Sie nach Familien- oder Wildlife-Safaris mit Kamelritt, Sandboarding und Abendessen im Camp – oder nach einer Morgensafari ohne späten Abend."
          ]
        },
        {
          "h": "Tipps für Dubai mit Kindern",
          "p": [
            "Planen Sie Aktivitäten im Freien für den Morgen und den späten Nachmittag und die Mittagszeit für Indoor-Ziele. Von Juni bis August steigt das Thermometer tagsüber oft über 40 °C: Dann sind Ski Dubai, das Aquarium, Indoor-Freizeitparks und die Wasserparks am Vormittag die besten Ziele, und Strand gibt es am frühen Morgen. Private Touren lassen sich im eigenen Tempo gestalten und bieten auf Wunsch oft Kindersitze.",
            "Die meisten Aktivitäten haben ermäßigte Kinderpreise, Kleinkinder sind oft gratis. Prüfen Sie Alters- und Größenvorgaben vor der Buchung; die Liste ist nach Bewertungen sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was kann man in Dubai mit Kleinkindern unternehmen?",
          "a": "Aquarien, ruhige Bootsfahrten, Strände mit flachem Wasser, Indoor-Spielbereiche und die Aussichtsplattformen. Dune Bashing und lange Touren in der Hitze sollten Sie meiden."
        },
        {
          "q": "Welche Sehenswürdigkeiten in Dubai lohnen sich mit Kindern?",
          "a": "Das Dubai Aquarium mit dem Unterwasserzoo in der Dubai Mall, der Wasserpark Aquaventure auf der Palm, Ski Dubai mit echtem Schnee und Pinguinen, die Aussicht vom Burj Khalifa und vom Dubai Frame und im Winter der Miracle Garden. Für jedes gibt es Tickets in dieser Liste."
        },
        {
          "q": "Ist eine Wüstensafari für Kinder geeignet?",
          "a": "Ja, wenn es die richtige ist: Ältere Kinder lieben das Dune Bashing meist, Familien mit kleinen Kindern wählen besser eine Safari ohne Dünenfahrt oder eine Wildlife-Safari mit Tieren und Camp."
        },
        {
          "q": "Zahlen Kinder bei Touren in Dubai den vollen Preis?",
          "a": "In der Regel nicht: Die meisten Touren und Attraktionen haben Kinderpreise, sehr kleine Kinder sind oft kostenlos. Die Altersstufen unterscheiden sich je nach Tour – prüfen Sie sie im jeweiligen Angebot."
        },
        {
          "q": "Wann reist man am besten mit Kindern nach Dubai?",
          "a": "Von Oktober bis April, wenn es warm, aber nicht zu heiß für Strand und Ausflüge ist. In den Schulferien ist viel los – beliebte Tickets daher früh buchen."
        },
        {
          "q": "Kann man im Sommer mit Kindern nach Dubai?",
          "a": "Ja, wenn der Tag nach drinnen verlegt wird: Von Juni bis August ist es draußen sehr heiß, aber Malls, Aquarien, Ski Dubai und Indoor-Freizeitparks sind klimatisiert, und Wasserparks und Strand gehen am Vormittag. Eine Wüstensafari am Morgen oder am Abend ist auch im Sommer möglich, längere Touren in der Mittagshitze nicht."
        },
        {
          "q": "Silvester in Dubai mit Kindern – geht das?",
          "a": "Ja, mit etwas Planung. Am Burj Khalifa drängen sich zu Mitternacht riesige Menschenmengen, die Straßen sind schon Stunden vorher gesperrt – mit kleinen Kindern anstrengend. Entspannter sind ein Platz mit Abstand, etwa an einem Strand oder auf einer Dhau- oder Yachtfahrt, oder Orte wie Global Village, die schon am frühen Abend mit Feuerwerk feiern. Mehr dazu auf unserer Silvester-Seite."
        },
        {
          "q": "Dubai oder Abu Dhabi mit Kindern?",
          "a": "Dubai hat mehr Auswahl auf engem Raum – Strände, Aquarium, Ski Dubai, Wasserparks. Abu Dhabi hat auf Yas Island die großen Freizeitparks wie Ferrari World, Warner Bros. World und SeaWorld. Viele Familien wohnen in Dubai und machen einen Tagesausflug nach Yas Island, etwa anderthalb Stunden entfernt."
        },
        {
          "q": "Welche Strände in Dubai sind gut für Kinder?",
          "a": "Die öffentlichen Strände JBR und Kite Beach haben flach abfallendes, ruhiges Wasser, Duschen und Rettungsschwimmer, viele Hotelstrände zusätzlich Spielplätze. Manche Beach Clubs lassen nur Erwachsene ein – prüfen Sie die Regeln, bevor Sie einen Tag dort planen."
        }
      ]
    },
    "day-trips": {
      "title": "Abu Dhabi & Tagesausflüge",
      "short": "Tages-\nausflüge",
      "intro": "Die Scheich-Zayid-Moschee und der Louvre in Abu Dhabi, die Berge von Hatta, die Fjorde von Musandam — Ausflüge, die einen ganzen Tag wert sind.",
      "meta": "Abu-Dhabi-Ausflug ab Dubai: Scheich-Zayid-Moschee, Louvre Abu Dhabi, Qasr Al Watan und Yas Island – dazu Tagesausflüge nach Hatta und Musandam.",
      "seoTitle": "Abu Dhabi Ausflug ab Dubai & weitere Tagestouren",
      "heading": "Abu Dhabi & Tagesausflüge ab Dubai",
      "guideTitle": "Die schönsten Tagesausflüge ab Dubai",
      "guide": [
        {
          "h": "Ein Abu-Dhabi-Ausflug ab Dubai",
          "p": [
            "Die Hauptstadt der Emirate liegt rund 90 Minuten entfernt und ist der beliebteste Tagesausflug ab Dubai. Eine klassische Stadttour holt Sie im Hotel ab und beginnt an der Scheich-Zayid-Moschee – einer der größten Moscheen der Welt, ganz aus weißem Marmor, mit Gold und Kristalllüstern –, danach geht es zum Louvre Abu Dhabi oder zum Präsidentenpalast Qasr Al Watan, über die Corniche und zu einem Halt am Emirates Palace.",
            "Viele Touren ergänzen Yas Island mit Ferrari World, Warner Bros. World und Yas Waterworld – als Fotostopp oder mit Parktickets für den Nachmittag. Ein ganzer Tag in Abu Dhabi dauert meist 8 bis 10 Stunden von Tür zu Tür."
          ]
        },
        {
          "h": "Besuch der Großen Moschee",
          "p": [
            "Der Eintritt in die Scheich-Zayid-Moschee ist frei, Besucher brauchen aber ein Zeitfenster, das die Tour organisiert. Die Moschee ist täglich geöffnet, nur am Freitagvormittag nicht – dann erst ab dem Nachmittag; die Touren planen das ein.",
            "Kleiden Sie sich zurückhaltend: lange Ärmel, lange Hosen oder ein knöchellanger Rock, nichts Enges oder Durchsichtiges, für Frauen ein Kopftuch. In den Gebetshallen werden die Schuhe ausgezogen. Der Louvre Abu Dhabi ist montags geschlossen, an diesem Tag besuchen die Touren stattdessen den Palast."
          ]
        },
        {
          "h": "Hatta und die Berge",
          "p": [
            "Hatta im Hadschar-Gebirge nahe der Grenze zum Oman ist ein Kontrast zur Stadt: türkisfarbenes Wasser am Staudamm, Kajakfahren, Mountainbiken, Wanderwege und ein Heritage Village. Es liegt etwa 90 Minuten von Dubai entfernt und ist in den kühleren Monaten am schönsten."
          ]
        },
        {
          "h": "Musandam, Sharjah und die Ostküste",
          "p": [
            "Musandam im Oman ist für seine Fjorde bekannt: Dhau-Fahrten zwischen Felswänden, Schnorcheln und Delfine. Es ist ein langer Tag mit Grenzübertritt – Reisepass mitnehmen und die Visaregeln für Ihre Staatsangehörigkeit prüfen.",
            "Näher an Dubai bietet Sharjah die besten Museen und das schönste Altstadtviertel der Region; die Ostküste rund um Fujairah lockt mit Stränden, Schnorcheln und alten Forts."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie lange dauert ein Abu-Dhabi-Ausflug ab Dubai?",
          "a": "Einen ganzen Tag: meist 8 bis 10 Stunden inklusive Fahrt, etwa 90 Minuten pro Strecke. Halbtagestouren umfassen die Große Moschee und einen weiteren Halt."
        },
        {
          "q": "Was trage ich in der Scheich-Zayid-Moschee?",
          "a": "Kleidung, die Arme und Beine bedeckt und weder eng noch durchsichtig ist, für Frauen ein Kopftuch. Wer die Kleiderordnung nicht erfüllt, wird nicht eingelassen – also vor der Abfahrt prüfen."
        },
        {
          "q": "Lohnt sich ein Tagesausflug von Dubai nach Abu Dhabi?",
          "a": "Ja – allein die Scheich-Zayid-Moschee rechtfertigt die Reise für die meisten Besucher, und eine Tour verbindet sie an einem Tag mit dem Louvre Abu Dhabi oder Yas Island, ganz ohne selbst zu fahren."
        },
        {
          "q": "Brauche ich für einen Tagesausflug ab Dubai einen Reisepass?",
          "a": "Für Musandam (Oman) immer, da Sie eine Grenze überqueren. Auch bei Ausflügen innerhalb der Emirate – Abu Dhabi, Hatta, Sharjah, Fujairah – sollten Sie Pass oder Ausweis dabeihaben; manche Touren verlangen ihn bei der Abholung."
        },
        {
          "q": "Wie lange dauern Tagesausflüge ab Dubai?",
          "a": "Die meisten 8 bis 10 Stunden inklusive Abholung und Rückfahrt. Musandam-Touren dauern wegen Fahrt und Grenzübertritt oft länger und beginnen sehr früh."
        },
        {
          "q": "Tour buchen oder selbst fahren?",
          "a": "Auf den Autobahnen der Emirate fährt es sich einfach, doch eine Tour erspart Parkplatzsuche und Routenplanung, enthält Eintritte und Guide und ist für Musandam mit seinen Grenzformalitäten die einfachste Lösung."
        }
      ]
    },
    "scenic-flights": {
      "title": "Rundflüge",
      "short": "Rund-\nflüge",
      "intro": "Im Heißluftballon bei Sonnenaufgang über die Dünen schweben oder im Hubschrauber an Burj Khalifa und der Palme vorbei — Dubai von oben.",
      "meta": "Heißluftballonfahrten über der Wüste von Dubai bei Sonnenaufgang und Helikopterflüge über Burj Khalifa, Palm und Dubai Marina – Rundflüge in Dubai.",
      "seoTitle": "Heißluftballon & Helikopterflug in Dubai",
      "heading": "Heißluftballon- und Helikopterflüge in Dubai",
      "guideTitle": "Dubai von oben erleben",
      "guide": [
        {
          "h": "Ballonfahrt bei Sonnenaufgang",
          "p": [
            "Ballonfahrten starten im Morgengrauen über der Wüste, wenn die Luft am ruhigsten ist, und schweben etwa eine Stunde über die Dünen – mit Blick auf Kamele, Gazellen und das Hadschar-Gebirge am Horizont. Die Abholung ist sehr früh, meist zwischen 4 und 5 Uhr, und die meisten Pakete enthalten ein Frühstück im Wüstencamp, manche auch eine Falknershow oder eine Fahrt im Oldtimer-Land-Rover.",
            "Die Fahrt hängt vom Wetter ab: Ist der Wind zu stark, sagt der Anbieter ab und bietet einen neuen Termin oder eine Erstattung an."
          ]
        },
        {
          "h": "Helikopterflüge über die Stadt",
          "p": [
            "Helikopterflüge beginnen bei etwa 12 Minuten und folgen der Küste vorbei an Burj Al Arab, Palm Jumeirah, Atlantis, Dubai Marina und Burj Khalifa. Längere Flüge zeigen zusätzlich den Dubai Creek, Alt-Dubai und die World Islands.",
            "Die Fensterplätze vergibt der Anbieter, oft nach Gewicht; ein privater Helikopter garantiert Ihrer Gruppe die Aussicht."
          ]
        },
        {
          "h": "Was soll es sein?",
          "p": [
            "Die Ballonfahrt steht für die Wüste bei Sonnenaufgang – langsam, still und ein ganzer Vormittag. Der Helikopter zeigt Skyline und Küste in wenigen Minuten und passt in jeden vollen Tag. Das schönste Licht haben der Ballon am frühen Morgen und der Helikopter am späten Nachmittag. Die Liste ist nach Bewertungen sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie viel Zeit braucht eine Heißluftballonfahrt in Dubai?",
          "a": "Planen Sie den ganzen Vormittag ein: Abholung vor Sonnenaufgang, etwa eine Stunde in der Luft, danach Frühstück und Programm im Camp, Rückkehr zum Hotel gegen späten Vormittag."
        },
        {
          "q": "Gibt es ein Mindestalter für Ballon- und Helikopterflüge?",
          "a": "Ja. Ballonanbieter nehmen Kinder meist ab etwa 5 Jahren in Begleitung mit, bei Helikopterflügen dürfen auch jüngere Kinder mit einem Erwachsenen mitfliegen. Schwangere können in der Regel nicht mit dem Ballon fahren."
        },
        {
          "q": "Was passiert, wenn die Ballonfahrt wetterbedingt ausfällt?",
          "a": "Der Anbieter entscheidet am Morgen der Fahrt. Fällt sie wegen Wind oder Sicht aus, erhalten Sie einen neuen Termin oder die volle Erstattung."
        },
        {
          "q": "Wann ist die beste Zeit für eine Ballonfahrt in Dubai?",
          "a": "In den kühleren Monaten von Oktober bis April – dann ist es am angenehmsten, und es gibt die meisten Fahrten. Im Sommer ist die Saison eingeschränkt, mit weniger Starts."
        }
      ]
    },
    "hot-air-balloon": {
      "title": "Heißluftballonfahrten",
      "intro": "Im Morgengrauen über der Wüste abheben und den Sonnenaufgang über den Dünen erleben — eine ruhige Stunde in der Luft, danach Frühstück im Wüstencamp.",
      "meta": "Heißluftballonfahrten in Dubai: Flüge bei Sonnenaufgang über die Wüstendünen mit Hotelabholung, Frühstück im Wüstencamp, Falknershow und Kamelritt.",
      "metaFrom": "Heißluftballon Dubai ab {{price}}: Ballonfahrt bei Sonnenaufgang über den Wüstendünen mit Hotelabholung, Frühstück im Wüstencamp, Falknershow und Kamelritt.",
      "seoTitle": "Heißluftballon Dubai: Ballonfahrt bei Sonnenaufgang",
      "heading": "Heißluftballonfahrten in Dubai",
      "guideTitle": "Heißluftballonfahrt in Dubai planen",
      "guide": [
        {
          "h": "So läuft der Morgen ab",
          "p": [
            "Ballonfahrten in Dubai starten bei Sonnenaufgang über der Wüste außerhalb der Stadt, wenn die Luft am ruhigsten ist. Die Abholung im Hotel ist sehr früh – meist zwischen 4 und 5 Uhr –, die Fahrt zum Startplatz dauert etwa eine Stunde. Sie sehen zu, wie der Ballon befüllt wird, steigen mit dem Piloten in den Korb und schweben rund eine Stunde über die Dünen, während das Licht von Blau zu Gold wechselt.",
            "Nach der Landung geht es bei den meisten Paketen am Boden weiter: Frühstück in einem Wüstencamp, oft eine Falknershow, manchmal ein Kamelritt oder eine Fahrt im Oldtimer-Land-Rover. Zurück im Hotel sind Sie meist am späten Vormittag."
          ]
        },
        {
          "h": "Standard, Premium oder privater Korb",
          "p": [
            "Beim Standardflug teilen Sie einen großen, in Abteile gegliederten Korb mit anderen Gästen. Premium-Pakete bieten kleinere Gruppen, ein besseres Frühstück oder Extras wie Falknerei und eine Wüstenfahrt; ein privater Korb ist nur für Ihre Gruppe gebucht – ideal für Heiratsanträge und Jahrestage.",
            "Manche Pakete kombinieren den Flug mit Dune Bashing oder einer Quadfahrt, einige starten in Ras Al Khaimah, etwa eine Stunde weiter nördlich. Jedes Angebot nennt die Leistungen und ob der Hoteltransfer inbegriffen ist."
          ]
        },
        {
          "h": "Wetter, Saison und was mitnehmen",
          "p": [
            "Ballone fahren nur bei ruhigem Wetter. Der Pilot entscheidet am Morgen selbst; lassen Wind oder Sicht den Flug nicht zu, erhalten Sie einen neuen Termin oder eine Erstattung. Die Saison läuft vor allem von Oktober bis April, im Sommer gibt es weniger Flüge.",
            "Wüstenmorgen sind kühl, auch wenn die Tage heiß sind: Nehmen Sie eine leichte Jacke mit, tragen Sie geschlossene Schuhe und halten Sie die Kamera griffbereit. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was kostet eine Ballonfahrt in Dubai?",
          "a": "Ein Platz im geteilten Korb mit Frühstück ist der Einstiegspreis; Premiumpakete mit kleinerem Korb, Falknershow oder Wüstenfahrt kosten mehr, ein privater Korb für Ihre Gruppe am meisten. Jede Karte zeigt den aktuellen Preis pro Person."
        },
        {
          "q": "Wie lange dauert eine Heißluftballonfahrt in Dubai?",
          "a": "Etwa eine Stunde in der Luft. Mit früher Abholung, Befüllen des Ballons, Frühstück und Rückfahrt nimmt der Ausflug den ganzen Vormittag ein – ungefähr von 4–5 Uhr bis zum späten Vormittag."
        },
        {
          "q": "Wann beginnt eine Ballonfahrt?",
          "a": "Bei Sonnenaufgang, die Uhrzeit ändert sich also mit der Jahreszeit. Die Abholung im Hotel ist meist zwischen 4 und 5 Uhr; der Veranstalter bestätigt die genaue Zeit am Vortag."
        },
        {
          "q": "Dürfen Kinder mit dem Heißluftballon fahren?",
          "a": "Meist ab 5 Jahren, bei manchen Flügen ab 7, immer mit einem Erwachsenen. Schwangeren und Menschen mit Rücken- oder Herzproblemen wird abgeraten – die Bedingungen des Anbieters stehen im Angebot."
        },
        {
          "q": "Was passiert, wenn der Flug abgesagt wird?",
          "a": "Sagt der Pilot wegen Wind oder Sicht ab, erhalten Sie einen neuen Termin oder eine Erstattung. Deshalb lohnt es sich, den Ballon früh im Urlaub zu buchen und einen freien Morgen als Reserve zu lassen."
        },
        {
          "q": "Wo starten die Ballonfahrten in Dubai?",
          "a": "In der Wüste im Landesinneren, etwa eine Stunde Fahrt von der Stadt. Der Startplatz richtet sich nach dem Wind am Morgen, deshalb ist die Hotelabholung im Paket. Einige Flüge starten in Ras Al Khaimah weiter nördlich."
        },
        {
          "q": "Gibt es Ballonfahrten bei Sonnenuntergang oder über der Stadt?",
          "a": "Nein: Freie Heißluftballons starten nur bei Sonnenaufgang, bevor die Hitze Wind aufkommen lässt, und fahren über die Wüste, fern der Stadt. Ein Ballon an der Palme oder ein günstiges Ballonticket ist ein Fesselballon – kurz hoch und wieder runter am Seil, keine Wüstenfahrt."
        },
        {
          "q": "Gibt es ein Gewichtslimit?",
          "a": "Ja, meist etwa 118–119 kg pro Person. Manche Anbieter berechnen schwereren Gästen einen zweiten Platz – prüfen Sie das Angebot vor der Buchung."
        }
      ]
    },
    "helicopter-tour": {
      "title": "Helikopterflüge",
      "intro": "Palm Jumeirah, Burj Al Arab und Burj Khalifa von oben — ein kurzer Flug entlang der Küste, ab 12 Minuten.",
      "meta": "Helikopterflüge in Dubai: Rundflüge ab Atlantis The Palm über Palm Jumeirah, Burj Al Arab, Dubai Marina und Burj Khalifa – geteilt oder privat.",
      "metaFrom": "Helikopterflug Dubai ab {{price}}: Rundflüge ab Atlantis The Palm über Palm Jumeirah, Burj Al Arab, Dubai Marina und Burj Khalifa – geteilt oder privat.",
      "seoTitle": "Helikopterflug Dubai: Rundflüge über die Stadt",
      "heading": "Helikopterflüge in Dubai",
      "guideTitle": "Helikopterflug in Dubai planen",
      "guide": [
        {
          "h": "Die Routen und wie lange Sie fliegen",
          "p": [
            "Die meisten Helikopterflüge in Dubai starten am Hubschrauberlandeplatz von Atlantis The Palm an der Spitze von Palm Jumeirah; andere heben in Jumeirah nahe der Mall of the Emirates oder an der Jumeirah Beach Residence ab. Der Standardflug dauert 12 Minuten: über die palmenförmige Insel, die Küste entlang am Burj Al Arab vorbei bis zum Burj Khalifa und zurück.",
            "Längere Flüge – je nach Anbieter 15, 17, 25 Minuten und bis zu einer Stunde – führen zusätzlich über Dubai Marina, die World Islands, die Sheikh Zayed Road und den Dubai Creek, wo die Altstadt entstand. Die Minuten sind die Zeit in der Luft; mit Check-in, Sicherheitseinweisung und Transfer sollten Sie zwei bis drei Stunden einplanen."
          ]
        },
        {
          "h": "Geteilt oder privat – und die Kombis",
          "p": [
            "Beim geteilten Flug sitzen Sie mit anderen Gästen im Helikopter, meist fünf oder sechs, und der Anbieter verteilt die Plätze – oft nach Gewicht, ein Fensterplatz ist also nicht garantiert. Ein privater Flug ist nur für Ihre Gruppe gebucht, Route und Uhrzeit wählen Sie selbst – ideal für Heiratsanträge, Geburtstage und Fotografen.",
            "Manche Pakete verbinden den Flug mit einer Wüstensafari am Nachmittag oder einem Abendessen im Atlantis The Palm, andere enthalten den Hoteltransfer hin und zurück. Jedes Angebot nennt den Startplatz, die Flugdauer und die Leistungen."
          ]
        },
        {
          "h": "Was Sie vor dem Flug wissen sollten",
          "p": [
            "Nehmen Sie Ihren Reisepass oder Ihre Emirates ID mit: Die Anbieter prüfen sie am Landeplatz, ohne Ausweis dürfen Sie nicht an Bord. Kommen Sie 30 bis 45 Minuten vorher. Taschen und lose Gegenstände bleiben am Boden – es gibt Schließfächer –, Handy und Kamera dürfen mit.",
            "Geflogen wird nur bei passendem Wetter: Halten Wind, Staub oder schlechte Sicht den Helikopter am Boden, erhalten Sie einen neuen Termin oder eine Erstattung. Die klarste Luft gibt es in den kühleren Monaten von Oktober bis April, das wärmste Licht über der Skyline am späten Nachmittag. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie lange dauert ein Helikopterflug in Dubai?",
          "a": "Der Standardflug dauert 12 Minuten in der Luft, längere Routen etwa 15 Minuten bis eine Stunde. Mit Check-in, Sicherheitseinweisung und Transfers dauert der Ausflug zwei bis drei Stunden."
        },
        {
          "q": "Was kostet ein Hubschrauberflug in Dubai?",
          "a": "Der Preis richtet sich nach den Minuten in der Luft: Der 12-Minuten-Flug über die Palme und den Burj Al Arab ist der Einstieg, längere Routen zum Burj Khalifa und zum Creek kosten mehr, ein privater Flug wird für den ganzen Helikopter berechnet. Jede Karte zeigt den aktuellen Preis."
        },
        {
          "q": "Wo starten Helikopterflüge in Dubai?",
          "a": "Meist am Hubschrauberlandeplatz von Atlantis The Palm auf Palm Jumeirah. Einige Anbieter fliegen von einem Landeplatz in Jumeirah nahe der Mall of the Emirates oder von der Jumeirah Beach Residence – das Angebot nennt den Startpunkt und ob die Hotelabholung inbegriffen ist."
        },
        {
          "q": "Was muss ich mitbringen?",
          "a": "Ihren Original-Reisepass oder Ihre Emirates ID – sie werden vor dem Einsteigen geprüft. Taschen kommen ins Schließfach am Landeplatz, Handy oder Kamera dürfen mit."
        },
        {
          "q": "Gibt es ein Gewichtslimit?",
          "a": "Ja, meist etwa 110–113 kg pro Person. Beim Check-in wird gewogen; schwerere Passagiere müssen unter Umständen einen zweiten Platz kaufen."
        },
        {
          "q": "Dürfen Kinder mitfliegen?",
          "a": "Ja, ab 2 Jahren mit einem Erwachsenen – jüngere Kinder nehmen die meisten Anbieter nicht mit, und ab 2 gilt meist der Erwachsenenpreis. Jeder Passagier, auch Kinder, braucht einen eigenen Ausweis. Die Bedingungen des Anbieters stehen im Angebot."
        },
        {
          "q": "Helikopter oder Heißluftballon?",
          "a": "Der Helikopter zeigt Skyline und Küste in wenigen Minuten und passt in jeden Tag. Der Ballon schwebt bei Sonnenaufgang über die Wüste und braucht den ganzen Vormittag – siehe die Heißluftballonfahrten."
        }
      ]
    },
    "quad-biking": {
      "title": "Quad & Buggy",
      "intro": "Selbst ans Steuer in den roten Dünen vor Dubai — mit dem Quad oder dem Dünenbuggy, als eigene Tour oder als Teil einer Wüstensafari.",
      "meta": "Quad- und Buggytouren in Dubai: selbst fahren in den roten Dünen, Wüstensafaris am Morgen und Abend mit Quad, Kamelritt und BBQ-Dinner.",
      "metaFrom": "Quad fahren in Dubai ab {{price}}: Quad- und Buggytouren in den roten Dünen, Wüstensafaris am Morgen und Abend mit Quad, Kamelritt und BBQ-Dinner.",
      "seoTitle": "Quad & Buggy Dubai: Selbst fahren in der Wüste",
      "heading": "Quad- und Buggytouren in Dubai",
      "guideTitle": "Quad- oder Buggytour in Dubai auswählen",
      "guide": [
        {
          "h": "Quad oder Dünenbuggy?",
          "p": [
            "Ein Quad (ATV) ist ein Einsitzer, den Sie wie ein Motorrad lenken, mit Daumengas – schnell erlernt und ideal für kleinere Dünen. Ein Dünenbuggy ist ein autoähnliches Fahrzeug mit Überrollkäfig und Gurten für zwei oder vier Personen; er bewältigt größere Dünen und passt für Paare und Familien, die zusammen fahren möchten.",
            "Bei beiden fahren Sie selbst: Ein Guide führt die Gruppe auf einer festgelegten Route durch die Wüste und passt das Tempo dem ungeübtesten Fahrer an. Helme und Schutzbrillen werden gestellt."
          ]
        },
        {
          "h": "Als eigene Tour oder mit Wüstensafari",
          "p": [
            "Viele Touren ergänzen eine klassische Wüstensafari um eine Quadfahrt: Dune Bashing im Geländewagen, Kamelritt, Sandboarding und am Abend ein Camp mit BBQ-Dinner und Shows. Andere sind reine Morgentouren von 30 Minuten bis zwei Stunden, wenn der Sand kühler und das Licht weicher ist.",
            "Gefahren wird in den roten Dünen südöstlich der Stadt, rund um Lahbab und Al Badayer, etwa 45 Minuten von Dubai entfernt. Die meisten Touren schließen die Hotelabholung ein; das Angebot nennt, wie lange Sie selbst fahren."
          ]
        },
        {
          "h": "Vor der Buchung",
          "p": [
            "Die Veranstalter legen ein Mindestalter für Fahrer fest – oft 16 Jahre fürs Quad und 18 für den Buggy –, jüngere Kinder fahren im Buggy meist als Beifahrer mit. Tragen Sie geschlossene Schuhe und bequeme Kleidung, die sandig werden darf, und nehmen Sie ein Tuch gegen den Staub mit.",
            "Morgentouren sind kühler und von Mai bis September die beste Wahl; im Winter sind die Abendsafaris mit Sonnenuntergang am beliebtesten. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Brauche ich einen Führerschein fürs Quadfahren in Dubai?",
          "a": "Für eine geführte Quadtour in der Wüste meist nicht, es gibt aber ein Mindestalter, oft 16 Jahre. Buggyfahrer müssen in der Regel mindestens 18 sein. Die Bedingungen des Veranstalters stehen im Angebot."
        },
        {
          "q": "Ab welchem Alter darf man in Dubai Quad fahren?",
          "a": "Das hängt vom Anbieter ab: Manche lassen Kinder ab 10 bis 13 Jahren mit Guide ein kleineres Quad fahren, die meisten setzen 16 Jahre fürs Erwachsenen-Quad, Buggyfahrer müssen meist 18 sein. Jüngere Kinder fahren im Buggy mit. Die Grenze steht im Angebot."
        },
        {
          "q": "Was kostet Quad fahren in Dubai?",
          "a": "Am günstigsten ist eine Safari mit kurzer Quadfahrt; eine eigene Stunde auf dem Quad oder im Buggy kostet mehr, der Buggy wird pro Fahrzeug berechnet. Bei vielen Safaris ist das Quad optional – prüfen Sie, ob es enthalten ist oder extra kostet."
        },
        {
          "q": "Wie lange dauert die Quadfahrt?",
          "a": "Das hängt von der Tour ab: Safari-Kombis enthalten oft 20–30 Minuten Fahrzeit, reine Quad- und Buggytouren ein bis zwei Stunden. Die Dauer steht im Angebot."
        },
        {
          "q": "Ist Quadfahren für Anfänger geeignet?",
          "a": "Ja, die Routen werden von einem Guide geführt, der zuerst die Bedienung erklärt und das Tempo vorgibt. Helme und Brillen werden gestellt. Wer nicht allein fahren möchte, wählt einen Zweisitzer-Buggy."
        },
        {
          "q": "Quadfahren morgens oder abends?",
          "a": "Morgens ist es kühler und ruhiger, ideal in den heißen Monaten. Abendtouren werden meist mit einer Wüstensafari, Sonnenuntergang und Abendessen im Camp kombiniert."
        },
        {
          "q": "Kann man ein Quad mieten und allein fahren?",
          "a": "Sie fahren Ihr eigenes Quad, aber nicht allein: In der Wüste führt immer ein Guide die Gruppe. Bei einer privaten Tour hat Ihre Gruppe einen eigenen Guide und ihr eigenes Tempo."
        },
        {
          "q": "Wo fährt man in Dubai Quad?",
          "a": "In den roten Dünen bei Lahbab und Al Badayer, etwa 45 Minuten südöstlich der Stadt. Fast alle Touren holen Sie im Hotel ab."
        }
      ]
    },
    "morning-desert-safari": {
      "title": "Wüstensafari am Morgen",
      "intro": "Rote Dünen in der Morgenkühle – Dune Bashing, Sandboarding, ein Kamelritt oder ein Quad, und am frühen Nachmittag zurück in der Stadt.",
      "meta": "Wüstensafari am Morgen in Dubai: Abholung im Hotel früh am Tag, Dune Bashing in den roten Dünen, Sandboarding, Kamelritt und Quads, zurück zum Mittag.",
      "metaFrom": "Wüstensafari am Morgen in Dubai ab {{price}}: Abholung im Hotel früh am Tag, Dune Bashing in den roten Dünen, Sandboarding, Kamelritt und Quads, zurück zum Mittag.",
      "seoTitle": "Morgen-Wüstensafari Dubai: Dünen, Kamele und Quads",
      "heading": "Wüstensafari am Morgen in Dubai",
      "guideTitle": "Wüstensafari am Morgen planen",
      "guide": [
        {
          "h": "So läuft der Morgen ab",
          "p": [
            "Eine Morgensafari beginnt mit der Abholung im Hotel gegen 7 oder 8 Uhr und einer Fahrt von etwa 45 Minuten in die roten Dünen südöstlich der Stadt, rund um Lahbab. Dort lässt der Fahrer Luft aus den Reifen und fährt den Geländewagen über die Dünen – Dune Bashing – mit Fotostopps auf den Kämmen.",
            "Dann folgen die Aktivitäten: Sandboarding eine Düne hinunter, ein kurzer Kamelritt und bei vielen Touren eine Fahrt mit Quad oder Dune Buggy, die Sie selbst steuern. Die meisten Ausflüge dauern drei bis fünf Stunden, sodass Sie zum Mittag oder am frühen Nachmittag wieder im Hotel sind."
          ]
        },
        {
          "h": "Morgens oder abends?",
          "p": [
            "Der Morgen ist kühler, in den Dünen ist weniger los, und die tief stehende Sonne zeichnet die Rippel im Sand – das beste Fotolicht nach Sonnenaufgang. Er passt zu Reisenden mit Plänen für den Abend, zu Familien mit kleinen Kindern, die früh schlafen gehen, und zu allen, die nachts abfliegen.",
            "Was am Morgen fehlt, ist das Camp: kein Barbecue-Abendessen, keine Feuer- oder Tanoura-Shows, kein Sonnenuntergang. Manche Touren bieten Wasser und Softdrinks, wenige ein leichtes Frühstück. Eine Heritage-Safari im Oldtimer zur Oase Al Marmoom ist die sanfte Variante, mit weniger Dune Bashing und mehr Tierbeobachtung."
          ]
        },
        {
          "h": "Praktische Tipps",
          "p": [
            "Tragen Sie leichte, bedeckende Kleidung und geschlossene Schuhe, und nehmen Sie Sonnenbrille, Sonnencreme und einen Hut mit: Der Sand heizt sich schnell auf, sobald die Sonne hoch steht. Von Mai bis September ist es schon am Vormittag heiß, nehmen Sie also die früheste Abholung; von Oktober bis April ist der ganze Morgen angenehm.",
            "Dune Bashing ist holprig und nichts für Schwangere oder Menschen mit Rücken- oder Nackenproblemen, und für Quads gilt ein Mindestalter – prüfen Sie das Angebot. Es gibt Gruppen- und Privattouren; jedes Angebot nennt die Leistungen, und die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wann beginnt eine Wüstensafari am Morgen?",
          "a": "Die Abholung im Hotel ist meist zwischen 7 und 8:30 Uhr, im Sommer früher. Mit Hin- und Rückfahrt enden die meisten Touren zwischen 11 und 13 Uhr."
        },
        {
          "q": "Was ist in einer Morgensafari enthalten?",
          "a": "Meist die Abholung im Hotel, Dune Bashing im Geländewagen, Sandboarding und ein kurzer Kamelritt, dazu Wasser oder Softdrinks. Quads oder Dune Buggys sind bei manchen Touren enthalten, bei anderen ein Extra; das Angebot sagt es."
        },
        {
          "q": "Ist eine Wüstensafari morgens oder abends besser?",
          "a": "Der Morgen ist kühler, ruhiger und besser für Fotos und lässt den Abend frei. Der Abend bietet den Sonnenuntergang und ein Camp mit Barbecue und Shows. Für die Dünen der Morgen, für das Camp der Abend."
        },
        {
          "q": "Ist eine Morgensafari für Kinder geeignet?",
          "a": "Ja – sie ist kürzer und kühler als die Abendsafari, und Kinder lieben Sandboarding und die Kamele. Für Dune Bashing gilt bei manchen Touren eine Altersgrenze, Quads meist ab 16; prüfen Sie das Angebot."
        },
        {
          "q": "Gibt es die Morgensafari auch im Sommer?",
          "a": "Ja, das ganze Jahr. Von Juni bis September nehmen Sie die früheste Abholung: Ab dem Vormittag wird der Sand heiß und die Dünen anstrengend. Von Oktober bis April ist der ganze Morgen angenehm."
        },
        {
          "q": "Lässt sich die Morgensafari mit einer Ballonfahrt verbinden?",
          "a": "Ja – manche Ballonpakete gehen nach dem Frühstück mit Dune Bashing oder einer Quadfahrt weiter, so bekommen Sie Sonnenaufgang und Dünen an einem Morgen. Sie stehen bei den Heißluftballonfahrten."
        }
      ]
    },
    "burj-khalifa": {
      "title": "Burj Khalifa Tickets",
      "intro": "At the Top auf den Etagen 124 und 125, SKY auf Etage 148 und The Lounge noch höher — Tickets für das höchste Gebäude der Welt, allein oder mit Stadtrundfahrt.",
      "meta": "Burj Khalifa Tickets: At the Top auf Etage 124–125, At the Top SKY auf 148 und The Lounge auf 152–154, dazu Kombis mit dem Dubai Aquarium und Stadttouren.",
      "seoTitle": "Burj Khalifa Tickets: At the Top, SKY & The Lounge",
      "heading": "Burj Khalifa Tickets & At the Top",
      "guideTitle": "Ihren Besuch im Burj Khalifa planen",
      "guide": [
        {
          "h": "Welche Etage buchen?",
          "p": [
            "Der Burj Khalifa ist 828 Meter hoch, und Besucher können auf drei Ebenen hinauf. At the Top auf den Etagen 124 und 125 ist die Hauptaussichtsplattform: ein 360-Grad-Blick über Downtown, den Golf und die Wüste, mit einer Freiluftterrasse auf Etage 124. At the Top SKY auf Etage 148 liegt höher und ist ruhiger, mit einer Lounge und kleineren Gruppen; das Ticket schließt die Etagen 124 und 125 mit ein.",
            "The Lounge auf den Etagen 152 bis 154 ist die höchste der drei — eher eine Lounge mit Getränken und kleinen Speisen als eine Plattform und die exklusivste Art, den Turm zu erleben."
          ]
        },
        {
          "h": "Sonnenuntergang, Tag oder Nacht",
          "p": [
            "Tickets werden für ein Zeitfenster verkauft. Am gefragtesten sind die Zeiten rund um den Sonnenuntergang — die Stadt färbt sich golden und leuchtet dann auf —, und sie sind zuerst ausgebucht, oft schon Tage im Voraus. Tagsüber reicht der Blick bei klarer Luft am weitesten über Küste und Wüste; nach Einbruch der Dunkelheit sehen Sie die Lichter der Sheikh Zayed Road und der Marina.",
            "Planen Sie oben etwa eine bis anderthalb Stunden ein, dazu die Sicherheitskontrolle und die Schlange an den Aufzügen. Im Sommer kann Dunst die Sicht trüben; die klarsten Tage gibt es meist im Winter."
          ]
        },
        {
          "h": "Anfahrt und Kombinationen",
          "p": [
            "Der Eingang zu At the Top liegt im Lower Ground Floor der Dubai Mall, die ein überdachter Gang mit der Metrostation Burj Khalifa/Dubai Mall verbindet. Nach dem Besuch läuft am Abend die Show der Dubai Fountain auf dem See unter dem Turm.",
            "Viele Tickets gibt es als Kombi — mit dem Dubai Aquarium & Underwater Zoo in derselben Mall, dem Dubai Frame, dem Miracle Garden oder einer halb- oder ganztägigen Stadttour mit Hotelabholung. Im Angebot steht, welche Etagen und Extras enthalten sind. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Welches Burj Khalifa Ticket soll ich kaufen?",
          "a": "Für die meisten Besucher At the Top auf den Etagen 124 und 125 — der klassische Blick, mit den meisten Zeitfenstern. At the Top SKY auf Etage 148 liegt höher und ist weniger voll; The Lounge auf den Etagen 152–154 bietet Getränke und den höchsten Ausblick, der Besuchern offensteht."
        },
        {
          "q": "Wann ist die beste Zeit für den Burj Khalifa?",
          "a": "Kurz vor Sonnenuntergang, wenn Sie ein Zeitfenster bekommen: So sehen Sie die Stadt bei Tag, im Abendlicht und beleuchtet bei Nacht in einem Besuch. Diese Zeiten sind zuerst weg, buchen Sie also ein paar Tage im Voraus; am frühen Morgen ist es am ruhigsten."
        },
        {
          "q": "Wie lange dauert ein Besuch bei At the Top?",
          "a": "Oben etwa eine bis anderthalb Stunden, dazu Sicherheitskontrolle und Aufzüge — rechnen Sie insgesamt mit zwei Stunden. Eine Kombi mit Stadttour dauert einen halben oder ganzen Tag."
        },
        {
          "q": "Wo ist der Eingang zum Burj Khalifa?",
          "a": "Im Lower Ground Floor der Dubai Mall, ausgeschildert als At the Top. Mit der Metro steigen Sie an der Station Burj Khalifa/Dubai Mall aus; Tickets mit Hotelabholung bringen Sie bis zum Eingang."
        }
      ]
    },
    "dubai-frame": {
      "title": "Dubai Frame Tickets",
      "intro": "Ein 150 Meter hoher Bilderrahmen im Zabeel Park mit gläsernem Boden oben auf der Brücke — auf der einen Seite das alte Dubai, auf der anderen die neue Skyline.",
      "meta": "Dubai Frame Tickets: die Glasbodenbrücke 150 m über dem Zabeel Park, mit Hoteltransfer oder als Kombi mit Burj Khalifa, Miracle Garden und AYA Universe.",
      "seoTitle": "Dubai Frame Tickets: Glasbrücke & Kombitickets",
      "heading": "Dubai Frame Tickets",
      "guideTitle": "Ihren Besuch im Dubai Frame planen",
      "guide": [
        {
          "h": "Was Sie sehen",
          "p": [
            "Der Dubai Frame ragt 150 Meter hoch im Zabeel Park auf, zwischen den alten Vierteln und der neuen Stadt, geformt wie ein riesiger Bilderrahmen. Ein Aufzug bringt Sie hinauf auf die Brücke, die seine beiden Türme verbindet und deren Boden teilweise aus Glas ist. Im Norden liegen Deira, Bur Dubai und der Creek, im Süden die Sheikh Zayed Road und der Burj Khalifa.",
            "Der Besuch beginnt in einer Galerie über Dubais Vergangenheit und endet in einer kurzen Ausstellung über die Zukunft der Stadt — er erzählt Dubais Geschichte also ebenso, wie er die Stadt zeigt."
          ]
        },
        {
          "h": "Wann hingehen und wie lange",
          "p": [
            "Planen Sie eine bis anderthalb Stunden ein. Der späte Nachmittag ist eine gute Zeit: Sie sehen die Stadt bei Tageslicht, dann gehen mit dem Sonnenuntergang die Lichter an. Am Morgen, kurz nach der Öffnung, ist es am ruhigsten.",
            "Der Einlass erfolgt nach Zeitfenster, und am Wochenende sowie in den kühleren Monaten, der Hauptsaison, bilden sich Schlangen am Aufzug — wer im Voraus bucht, spart sich das Warten."
          ]
        },
        {
          "h": "Tickets mit Transfer und Kombis",
          "p": [
            "Von der nächsten Metrostation ist der Frame ein gutes Stück zu Fuß entfernt, deshalb enthalten viele Tickets die Abholung vom Hotel und die Rückfahrt. Andere kombinieren ihn mit dem Burj Khalifa, dem Miracle Garden, dem Global Village oder AYA Universe oder mit einer Dhau-Fahrt am Abend — ein ganzer Tag Sightseeing in einer Buchung.",
            "Miracle Garden und Global Village haben nur in den kühleren Monaten geöffnet, etwa von Herbst bis Frühjahr, ihre Kombis gibt es also nur saisonal. Im Angebot steht, was enthalten ist. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie hoch ist der Dubai Frame?",
          "a": "150 Meter. Die Aussichtsbrücke oben verbindet seine beiden Türme und hat einen Abschnitt mit Glasboden, über den Sie gehen können."
        },
        {
          "q": "Wie lange dauert ein Besuch im Dubai Frame?",
          "a": "Etwa eine bis anderthalb Stunden, mit der Galerie zu Beginn, der Brücke oben und der Ausstellung auf dem Weg nach draußen."
        },
        {
          "q": "Burj Khalifa oder Dubai Frame?",
          "a": "Beide zeigen Verschiedenes: Der Burj Khalifa blickt aus viel größerer Höhe auf die ganze Stadt, der Frame stellt das alte und das neue Dubai aus 150 Metern nebeneinander — und ist meist weniger voll. Mit Kombitickets schaffen Sie beides an einem Tag."
        },
        {
          "q": "Wie komme ich zum Dubai Frame?",
          "a": "Er steht im Zabeel Park, zwischen Bur Dubai und Downtown. Nehmen Sie ein Taxi oder ein Ticket mit Hoteltransfer; von den nächsten Metrostationen sind es 15–20 Minuten zu Fuß."
        }
      ]
    },
    "aquaventure": {
      "title": "Aquaventure Wasserpark",
      "intro": "Der Wasserpark des Atlantis The Palm: Rekordrutschen durch eine Haifischlagune, ein langer Lazy River, eine Surfwelle und ein eigener Strand.",
      "meta": "Aquaventure Tickets im Atlantis The Palm: Tagespässe für Dubais größten Wasserpark, mit Lost Chambers Aquarium als Kombi, Hoteltransfer und Haibegegnungen.",
      "seoTitle": "Aquaventure Dubai Tickets: Wasserpark im Atlantis",
      "heading": "Aquaventure Wasserpark Tickets",
      "guideTitle": "Ihren Tag im Aquaventure planen",
      "guide": [
        {
          "h": "Was der Park bietet",
          "p": [
            "Aquaventure ist der Wasserpark des Atlantis The Palm an der äußeren Spitze der Palm Jumeirah und einer der größten der Welt, mit über 100 Rutschen und Attraktionen. Am bekanntesten sind der Leap of Faith, ein fast senkrechter Fall durch eine Lagune mit Haien, Poseidon's Revenge und die Aquaconda, eine der größten Wasserrutschen überhaupt.",
            "Zwischen den Rutschen gibt es einen langen Lazy River mit Stromschnellen, eine Surfwelle, Planschbereiche für kleine Kinder und einen eigenen Strand — alles im Tagespass enthalten."
          ]
        },
        {
          "h": "Tagespass, Kombis und Extras",
          "p": [
            "Der Tagespass deckt die Rutschen, den Fluss und den Strand ab. Kombitickets fügen das Lost Chambers Aquarium im Atlantis mit seinen Becken in einer versunkenen Stadt hinzu; andere enthalten Hoteltransfer, Mittagessen oder eine Begegnung mit Haien oder Delfinen.",
            "Ein Fast-Track-Pass, Schließfächer, Handtücher und Cabanas kosten meist extra. Im Angebot steht, was enthalten ist und welche Option Sie buchen."
          ]
        },
        {
          "h": "Tipps für den Tag",
          "p": [
            "Planen Sie einen ganzen Tag ein und kommen Sie zur Öffnung, wenn die Schlangen an den großen Rutschen am kürzesten sind. Der Park ist das ganze Jahr geöffnet; an Sommertagen sind der Morgen und der späte Nachmittag am angenehmsten.",
            "Manche Rutschen haben eine Mindestgröße — prüfen Sie sie, bevor Sie Kindern eine Fahrt versprechen. Die Palm Monorail endet an der Station Atlantis Aquaventure direkt am Park; Tickets mit Transfer holen Sie im Hotel ab. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Ist das Lost Chambers Aquarium im Aquaventure Ticket enthalten?",
          "a": "Im normalen Tagespass nicht — buchen Sie für beides ein Kombiticket. Im Angebot steht, welche Option Sie buchen."
        },
        {
          "q": "Wie komme ich zum Aquaventure?",
          "a": "Es liegt im Atlantis The Palm am Ende der Palm Jumeirah. Die Palm Monorail fährt bis zur Station Atlantis Aquaventure; ein Taxi oder ein Ticket mit Hoteltransfer bringt Sie bis zum Eingang."
        },
        {
          "q": "Ist Aquaventure für kleine Kinder geeignet?",
          "a": "Ja: Es gibt Planschbereiche und sanfte Rutschen für kleine Kinder, und im Park liegen Schwimmwesten bereit. Für die großen Rutschen gilt eine Mindestgröße, jüngere Kinder dürfen dort also eventuell nicht fahren."
        },
        {
          "q": "Ist der Strand inklusive?",
          "a": "Ja, der Tagespass schließt den eigenen Strand des Parks ein — zwischen den Rutschen können Sie also im Meer baden."
        }
      ]
    },
    "miracle-garden": {
      "title": "Tickets für den Miracle Garden",
      "intro": "Der größte natürliche Blumengarten der Welt – Bögen, Schlösser und ein Emirates-A380 aus Blumen. Nur in den kühleren Monaten geöffnet.",
      "meta": "Tickets für den Dubai Miracle Garden: Eintritt mit oder ohne Hoteltransfer und Kombis mit Dubai Frame, Burj Khalifa, Global Village und Butterfly Garden.",
      "seoTitle": "Dubai Miracle Garden: Tickets und Kombis",
      "heading": "Tickets für den Dubai Miracle Garden",
      "guideTitle": "Besuch im Dubai Miracle Garden planen",
      "guide": [
        {
          "h": "Was Sie dort sehen",
          "p": [
            "Der Dubai Miracle Garden in Dubailand ist der größte natürliche Blumengarten der Welt: rund 150 Millionen Blumen auf 72.000 Quadratmetern, geformt zu herzförmigen Bögen, Wegen unter bunten Schirmen, Blumenschlössern und lebensgroßen Figuren. Das bekannteste Stück ist ein Emirates-A380 in Originalgröße, ganz mit Blumen bedeckt – ein Eintrag im Guinness-Buch der Rekorde.",
            "Die Arrangements werden jede Saison neu gestaltet, ein zweiter Besuch zeigt also neue Themen. Die Wege sind eben und teils schattig, mit Cafés, Sitzplätzen und Toiletten; zwei bis drei Stunden reichen für den ganzen Garten."
          ]
        },
        {
          "h": "Ein Garten mit Saison",
          "p": [
            "Der Garten liegt im Freien und ist nur in den kühleren Monaten geöffnet: Er öffnet meist im Herbst, etwa im Oktober oder November, und schließt, wenn die Sommerhitze kommt, etwa im Mai oder Juni – die genauen Termine werden jedes Jahr bekanntgegeben. Außerhalb der Saison ist er geschlossen, prüfen Sie die Daten also vor der Buchung.",
            "Geöffnet ist täglich vom Vormittag bis zum Abend, am Wochenende länger. Am angenehmsten ist der späte Nachmittag: kühlere Luft, weicheres Licht für Fotos und nach Sonnenuntergang der beleuchtete Garten."
          ]
        },
        {
          "h": "Tickets, Transfers und Kombis",
          "p": [
            "Ein Eintrittsticket genügt; viele Angebote enthalten einen Hoteltransfer – praktisch, denn in der Nähe des Gartens gibt es keine Metrostation, mit dem Taxi sind es etwa 20 bis 30 Minuten von Downtown oder der Marina. Skip-the-Line-Tickets sparen an vollen Wochenendabenden die Schlange am Eingang.",
            "Etwa die Hälfte der Tickets sind Kombis: mit dem benachbarten Butterfly Garden, dem Dubai Frame, Burj Khalifa At the Top oder einem Abend im Global Village, das in derselben Saison geöffnet ist. Jedes Angebot nennt die Leistungen. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wann ist der Dubai Miracle Garden geöffnet?",
          "a": "Nur in den kühleren Monaten: Er öffnet meist etwa im Oktober oder November und schließt etwa im Mai oder Juni, die genauen Termine werden jede Saison bekanntgegeben. Geöffnet ist täglich vom Vormittag bis zum Abend, am Wochenende länger."
        },
        {
          "q": "Wie viel Zeit braucht man im Miracle Garden?",
          "a": "Zwei bis drei Stunden für den ganzen Garten. Mit dem benachbarten Butterfly Garden sollten Sie einen halben Tag einplanen."
        },
        {
          "q": "Wie kommt man zum Dubai Miracle Garden?",
          "a": "Er liegt in Dubailand, mit dem Taxi etwa 20–30 Minuten von Downtown oder Dubai Marina, ohne Metrostation in der Nähe. Viele Tickets enthalten einen Hoteltransfer – das Angebot sagt, ob er dabei ist."
        },
        {
          "q": "Ist der Butterfly Garden inbegriffen?",
          "a": "Nicht mit einem reinen Miracle-Garden-Ticket: Er ist eine eigene Attraktion nebenan. Kombitickets decken beide ab – achten Sie auf „Butterfly Garden“ im Titel."
        }
      ]
    },
    "global-village": {
      "title": "Global Village Dubai",
      "intro": "Ein saisonaler Freiluft-Festivalpark mit Länderpavillons, Streetfood aus aller Welt, Bühnenshows und einem Rummelplatz. Geöffnet in den kühleren Monaten, vom späten Nachmittag bis spät in die Nacht.",
      "meta": "Global Village Dubai: was Sie sehen, wann geöffnet ist, wie Sie hinkommen – und Eintrittstickets mit Hoteltransfer oder als Kombi mit dem Miracle Garden.",
      "seoTitle": "Global Village Dubai: Tipps, Öffnungszeiten & Tickets",
      "heading": "Global Village Dubai",
      "guideTitle": "Einen Abend im Global Village planen",
      "guide": [
        {
          "h": "Was das Global Village ist",
          "p": [
            "Das Global Village ist ein großer Freiluft-Festivalpark in Dubailand am Stadtrand. Rund dreißig Pavillons, jeder im Baustil eines Landes oder einer Region, verkaufen Kunsthandwerk, Süßigkeiten, Gewürze, Stoffe und Souvenirs aus rund 90 Kulturen – von der Türkei, Indien und Marokko bis China, Afrika und dem Golf.",
            "Zwischen den Pavillons liegen Hunderte Imbissstände und Restaurants, eine Hauptbühne und kleinere Bühnen mit Musik- und Tanzshows, ein See mit Vorführungen auf dem Wasser und Carnaval, ein Rummelplatz, dessen Fahrgeschäfte getrennt vom Eintritt bezahlt werden. An Wochenendabenden gibt es Feuerwerk."
          ]
        },
        {
          "h": "Wann geöffnet ist",
          "p": [
            "Das Global Village ist eine Winterattraktion: Die Saison beginnt meist im Oktober und dauert bis etwa Anfang Mai, die genauen Termine werden jedes Jahr bekanntgegeben. Im Sommer ist der Park geschlossen.",
            "Geöffnet ist vom späten Nachmittag bis etwa Mitternacht, am Wochenende länger. Die meisten kommen gegen Sonnenuntergang, wenn es kühler wird und die Pavillons beleuchtet sind; unter der Woche ist es abends spürbar leerer als freitags und samstags. Planen Sie drei bis vier Stunden ein – mehr, wenn Sie Fahrgeschäfte und ein Abendessen im Restaurant möchten."
          ]
        },
        {
          "h": "Anfahrt und Tickets",
          "p": [
            "Der Park liegt an der Sheikh Mohammed Bin Zayed Road, mit dem Taxi etwa 25–30 Minuten von Downtown und etwas länger von der Dubai Marina. Eine Metrostation gibt es in der Nähe nicht; öffentliche Busse fahren von mehreren Metrostationen, und es gibt einen großen Parkplatz. Viele der Angebote unten enthalten einen Hoteltransfer – so müssen Sie sich um die Taxis des Abends nicht kümmern.",
            "Eintrittstickets gibt es als günstigere Wochentagstickets und als Tickets für jeden Tag; kleine Kinder haben freien Eintritt. Fahrgeschäfte, Spiele und Essen bezahlen Sie vor Ort. Der Miracle Garden liegt ebenfalls in Dubailand, eine kurze Fahrt entfernt, und hat dieselbe Saison – mehrere Angebote verbinden deshalb beide an einem Nachmittag und Abend. Jedes Angebot nennt die Leistungen; die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wann hat das Global Village geöffnet?",
          "a": "In den kühleren Monaten: Eine Saison dauert meist von Oktober bis etwa Anfang Mai, die Termine werden jedes Jahr bekanntgegeben. Geöffnet ist täglich vom späten Nachmittag bis etwa Mitternacht, am Wochenende länger."
        },
        {
          "q": "Wie viel Zeit braucht man im Global Village?",
          "a": "Drei bis vier Stunden, um durch die Pavillons zu gehen, zu essen und eine Show zu sehen; mit den Fahrgeschäften von Carnaval einen halben Tag oder mehr."
        },
        {
          "q": "Wie kommt man zum Global Village?",
          "a": "Es liegt in Dubailand, mit dem Taxi etwa 25–30 Minuten von Downtown Dubai, ohne Metrostation in der Nähe. Öffentliche Busse fahren von mehreren Metrostationen, und viele Tickets enthalten einen Hoteltransfer – das Angebot sagt, ob er dabei ist."
        },
        {
          "q": "Sind die Fahrgeschäfte im Eintritt enthalten?",
          "a": "Nein. Der Eintritt umfasst die Pavillons, die Shows und das Feuerwerk; die Fahrgeschäfte und Spiele von Carnaval werden im Park extra bezahlt."
        },
        {
          "q": "Kann man Global Village und Miracle Garden an einem Tag besuchen?",
          "a": "Ja: Beide liegen in Dubailand, eine kurze Fahrt voneinander entfernt, und haben dieselbe Saison. Am Nachmittag in den Miracle Garden, nach Sonnenuntergang ins Global Village – Kombitickets decken beides ab."
        }
      ]
    },
    "ski-dubai": {
      "title": "Tickets für Ski Dubai",
      "intro": "Echter Schnee bei Minusgraden mitten in einem Einkaufszentrum – Snow Park, Sessellift, Piste und eine Pinguinkolonie, das ganze Jahr geöffnet.",
      "meta": "Tickets für Ski Dubai: Tagespässe für den Snow Park mit Winterkleidung, Sessellift und Fahrgeschäften, Pinguine und die Piste in der Mall of the Emirates.",
      "seoTitle": "Ski Dubai Tickets: Snow Park und Indoor-Piste",
      "heading": "Tickets für Ski Dubai",
      "guideTitle": "Einen Tag in Ski Dubai planen",
      "guide": [
        {
          "h": "Schnee in der Wüste",
          "p": [
            "Ski Dubai ist das Indoor-Skigebiet in der Mall of the Emirates – das erste im Nahen Osten –, das ganzjährig auf etwa −1 bis −2 °C gekühlt wird, mit 6.000 Tonnen echtem Schnee. Die Piste ist rund 400 Meter lang, mit Sessellift und Schlepplift, dazu eine Freestyle-Zone mit Sprüngen und Rampen.",
            "Die meisten Besucher kommen für den Snow Park daneben: Rodel- und Tubingbahnen, eine Schneehöhle, Riesenball-Fahrten, die Mountain-Thriller-Bahn und Schneeballschlachten. Außerdem lebt hier eine Kolonie von Esels- und Königspinguinen; der „March of the Penguins“, mehrmals täglich, ist für Snow-Park-Gäste kostenlos."
          ]
        },
        {
          "h": "Welches Ticket?",
          "p": [
            "Ein Snow-Park-Ticket bietet den ganzen Tag Zugang zum Park mit Winterkleidung – Jacke, Hose, Stiefel und Socken – und meist eine Fahrt mit dem Sessellift und dem Mountain Thriller. Die Plus-Tickets enthalten weitere Fahrten, etwa die Snow-Bullet-Seilrutsche über der Piste. Zum Ski- oder Snowboardfahren auf der Hauptpiste brauchen Sie einen Pistenpass und müssen kurven und bremsen können; Anfänger buchen zuerst eine Stunde.",
            "Manche Angebote enthalten einen privaten Hoteltransfer, andere kombinieren Ski Dubai mit der Dubai Ice Rink oder einem Hop-on-Hop-off-Bus. Jedes Angebot nennt die enthaltenen Fahrten und die Ausrüstung. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        },
        {
          "h": "Praktische Tipps",
          "p": [
            "Die Mall of the Emirates hat eine eigene Station an der roten Metrolinie, die Anreise ist also auch ohne Transfer einfach. Handschuhe und Mütze gehören nicht immer zur Kleidung – bringen Sie eigene mit oder kaufen Sie sie im Shop. Für Kinder unter 13 ist bei den Fahrten ein Helm Pflicht.",
            "Ski Dubai ist ganzjährig geöffnet, vom Vormittag bis spät am Abend, und am vollsten an Wochenenden und an Sommernachmittagen, wenn es der kühlste Ort der Stadt ist. Zwei bis drei Stunden im Snow Park reichen den meisten Familien."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was ist in einem Ski-Dubai-Ticket enthalten?",
          "a": "Ein Snow-Park-Ticket umfasst den ganztägigen Zugang zum Park, Winterkleidung – Jacke, Hose, Stiefel und Socken – und meist eine Fahrt mit dem Sessellift und dem Mountain Thriller. Plus-Tickets enthalten weitere Fahrten; das Angebot nennt sie genau."
        },
        {
          "q": "Brauche ich warme Kleidung für Ski Dubai?",
          "a": "Nein: Jacke, Hose, Stiefel und Socken werden gestellt. Handschuhe und Mütze sind nicht immer dabei – bringen Sie eigene mit oder kaufen Sie sie vor Ort; tragen Sie unter dem Anzug lange Hosen und Socken."
        },
        {
          "q": "Können Anfänger in Ski Dubai Ski fahren?",
          "a": "Im Snow Park kann jeder rodeln und im Schnee spielen. Die Hauptpiste ist für Ski- und Snowboardfahrer, die kurven und bremsen können; Anfänger nehmen zuerst eine Stunde."
        },
        {
          "q": "Ist Ski Dubai etwas für Kinder?",
          "a": "Ja – Snow Park, Fahrgeschäfte und Pinguine sind für Familien gemacht. Sehr kleine Kinder dürfen nicht auf alle Fahrten, und unter 13 ist ein Helm Pflicht; die Altersregeln stehen im Angebot."
        }
      ]
    },
    "dubai-aquarium": {
      "title": "Tickets für das Dubai Aquarium",
      "intro": "Haie und Rochen über Ihrem Kopf im Glastunnel, Pinguine und Otter im Zoo darüber – in der Dubai Mall, direkt am Fuß des Burj Khalifa.",
      "meta": "Tickets für Dubai Aquarium & Underwater Zoo: Glastunnel, Unterwasserzoo, Penguin Cove und Kombis mit Burj Khalifa At the Top, in der Dubai Mall.",
      "seoTitle": "Dubai Aquarium Tickets: Tunnel und Unterwasserzoo",
      "heading": "Tickets für das Dubai Aquarium",
      "guideTitle": "Besuch im Dubai Aquarium planen",
      "guide": [
        {
          "h": "Becken, Tunnel und Zoo",
          "p": [
            "Das Dubai Aquarium & Underwater Zoo liegt im Erdgeschoss der Dubai Mall in Downtown Dubai. Sein Becken mit 10 Millionen Litern beherbergt Tausende Tiere – Sandtigerhaie, Rochen, Zackenbarsche und Schwärme von Rifffischen – hinter einer der größten Acrylscheiben der Welt. Einen Teil des Beckens sieht man kostenlos von der Mall aus; mit dem Ticket geht es hinein.",
            "Drinnen führt ein etwa 48 Meter langer Tunnel unter dem Becken hindurch, Haie und Rochen schwimmen über und neben Ihnen. Eine Etage höher zeigt der Unterwasserzoo Pinguine, Otter, ein Krokodil sowie Tiere des Regenwalds und der Felsküste, mit Fütterungen und Pflegervorträgen über den Tag verteilt."
          ]
        },
        {
          "h": "Welches Ticket passt",
          "p": [
            "Das Basisticket umfasst den Tunnel und den Unterwasserzoo. Penguin-Cove-Tickets fügen den Pinguinbereich hinzu, die Explorer-Tickets noch mehr, etwa eine Fahrt im Glasbodenboot über das Becken oder einen Blick hinter die Kulissen. Haitauchen und Käfigschnorcheln werden separat gebucht und haben Alters- und Schwimmregeln.",
            "Der Burj Khalifa steht in derselben Mall, daher verbinden viele Angebote das Aquarium mit At the Top, oft mit Hoteltransfer. Andere enthalten nur den Transport. Jedes Angebot nennt die enthaltenen Bereiche und Extras. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        },
        {
          "h": "Praktische Tipps",
          "p": [
            "Die Metrostation Burj Khalifa/Dubai Mall der Roten Linie ist über einen klimatisierten Gang mit der Mall verbunden. Das Aquarium ist täglich vom Morgen bis spät am Abend geöffnet; am ruhigsten ist es an Werktagen vormittags, am vollsten an Wochenendnachmittagen.",
            "Für Tunnel und Zoo reichen ein bis zwei Stunden; mit Bootsfahrt oder Tierbegegnung kommt eine Stunde dazu. Bei einer Kombi buchen Sie zuerst das Zeitfenster für den Burj Khalifa und besuchen das Aquarium davor oder danach – die beiden Eingänge liegen wenige Gehminuten auseinander."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was ist in einem Ticket für das Dubai Aquarium enthalten?",
          "a": "Das Basisticket umfasst den Tunnel und den Unterwasserzoo. Penguin-Cove- und Explorer-Tickets fügen den Pinguinbereich und Extras wie eine Fahrt im Glasbodenboot hinzu; das Angebot nennt sie genau."
        },
        {
          "q": "Kann man das Dubai Aquarium kostenlos sehen?",
          "a": "Einen Teil des Hauptbeckens sieht man ohne Ticket durch die große Scheibe im Erdgeschoss der Dubai Mall. Für den Tunnel unter dem Becken und den Unterwasserzoo braucht man eines."
        },
        {
          "q": "Wie lange dauert ein Besuch im Dubai Aquarium?",
          "a": "Die meisten Besucher verbringen ein bis zwei Stunden in Tunnel und Zoo. Eine Glasbodenbootfahrt, eine Pinguinbegegnung oder eine Kombi mit dem Burj Khalifa verlängern den Besuch um ein bis drei Stunden."
        },
        {
          "q": "Ist das Dubai Aquarium für Kinder geeignet?",
          "a": "Ja – Tunnel, Pinguine und Otter sind bei Familien sehr beliebt, und der Besuch findet drinnen und klimatisiert statt. Haitauchen und manche Begegnungen haben ein Mindestalter; prüfen Sie das Angebot."
        }
      ]
    },
    "yas-island": {
      "title": "Tickets für Yas Island",
      "intro": "Abu Dhabis Insel der Freizeitparks – Ferrari World, Warner Bros. World, Yas Waterworld und SeaWorld – als Tagesausflug ab Dubai.",
      "meta": "Tickets für Yas Island ab Dubai: Ferrari World, Warner Bros. World Abu Dhabi, Yas Waterworld und Kombipässe, mit Hoteltransfer oder Stadtrundfahrt.",
      "seoTitle": "Yas Island Tickets: Ferrari World und Warner Bros",
      "heading": "Tickets für die Freizeitparks auf Yas Island",
      "guideTitle": "Einen Tag auf Yas Island planen",
      "guide": [
        {
          "h": "Die Parks",
          "p": [
            "Auf Yas Island am Rand von Abu Dhabi liegen die größten Freizeitparks des Landes nur wenige Minuten voneinander entfernt. Ferrari World unter seinem riesigen roten Dach ist die Heimat der Formula Rossa, einer der schnellsten Achterbahnen der Welt, dazu kommen ruhigere Fahrgeschäfte und die Geschichte der Marke. Auch Warner Bros. World ist überdacht, mit Looney Tunes und DC-Superhelden in Themenwelten wie Gotham City und Metropolis.",
            "Daneben liegen Yas Waterworld, ein Wasserpark unter freiem Himmel mit Rutschen und Wellenbecken, SeaWorld Yas Island, ein Meerespark mit Fahrgeschäften und Shows unter einem Dach, und CLYMB mit Indoor-Skydiving und Kletterwand. Auf dem Yas Marina Circuit findet zum Jahresende der Formel-1-Grand-Prix von Abu Dhabi statt."
          ]
        },
        {
          "h": "Welches Ticket passt",
          "p": [
            "Ein Einzelticket gilt für einen Tag in einem Park. Mit Kombipässen wählen Sie zwei oder drei Parks an mehreren Tagen – lohnend, wenn Sie in Abu Dhabi übernachten oder wiederkommen. Bei manchen Angeboten wählen Sie den Park bei der Buchung.",
            "Ab Dubai enthalten viele Angebote einen Hoteltransfer, manche verbinden den Park mit einer Stadtrundfahrt durch Abu Dhabi – vormittags die Scheich-Zayid-Moschee, nachmittags ein Park. Jedes Angebot nennt Park, Transport und Stopps. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        },
        {
          "h": "Praktische Tipps",
          "p": [
            "Yas Island liegt etwa anderthalb Stunden Fahrt von Dubai entfernt, im Berufsverkehr länger – ein Parktag ist also ein ganzer Tag: morgens losfahren und zur Öffnung ankommen. Ferrari World, Warner Bros. World und SeaWorld sind überdacht und klimatisiert und damit eine gute Wahl im Sommer; Yas Waterworld besuchen Sie am besten von Oktober bis April oder früh am Tag.",
            "Für die großen Fahrgeschäfte gelten Mindestgrößen und Gesundheitsregeln – prüfen Sie sie vorab, wenn Sie mit Kindern reisen. Bei einer Kombi mit der Großen Moschee brauchen Sie Kleidung, die Arme und Beine bedeckt, und Frauen ein Kopftuch."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wie weit ist Yas Island von Dubai entfernt?",
          "a": "Etwa anderthalb Stunden Fahrt vom Zentrum Dubais, von Dubai Marina und Jebel Ali etwas weniger. Die meisten Angebote enthalten den Hoteltransfer hin und zurück."
        },
        {
          "q": "Welcher Park auf Yas Island ist am besten für Kinder?",
          "a": "Warner Bros. World passt am besten zu jüngeren Kindern, mit Zeichentrickfiguren und sanften Fahrgeschäften. Ferrari World und Yas Waterworld haben mehr Nervenkitzel für Teenager; SeaWorld passt für jedes Alter."
        },
        {
          "q": "Kann man zwei Parks an einem Tag besuchen?",
          "a": "Möglich, aber anstrengend: Jeder Park füllt leicht einen Tag. Kombipässe gelten an mehreren Tagen, daher verteilen die meisten Besucher sie."
        },
        {
          "q": "Sind die Parks auf Yas Island im Sommer geöffnet?",
          "a": "Ja – Ferrari World, Warner Bros. World und SeaWorld sind ganzjährig überdacht und klimatisiert. Yas Waterworld liegt im Freien; im Sommer gehen Sie früh, vor der Mittagshitze."
        }
      ]
    },
    "date-night": {
      "title": "Date Night",
      "short": "Date Night",
      "intro": "Sonnenuntergangsfahrten, Dinner mit Aussicht und Abende in der Wüste — Ideen für einen Abend zu zweit.",
      "meta": "Date-Night-Ideen in Dubai: Sonnenuntergangsfahrten, Dinner mit Aussicht und romantische Abende in der Wüste."
    },
    "beach-days": {
      "title": "Strandtage",
      "short": "Strandtage",
      "intro": "Beach Clubs, Bootstage und Zeit auf dem Wasser an Jumeirah, der Palme und der Marina.",
      "meta": "Strandtage in Dubai: Beach Clubs, Bootsausflüge und Zeit auf dem Wasser an Jumeirah, der Palme und der Dubai Marina."
    },
    "art-and-culture": {
      "title": "Kunst & Kultur",
      "short": "Kunst & Kultur",
      "intro": "Museen, Galerien, historische Viertel und die Geschichten hinter Moscheen und Souks.",
      "meta": "Kunst und Kultur in Dubai: Museen, Galerien, historische Viertel, Moscheen und Souks."
    },
    "luxury": {
      "title": "Luxuserlebnisse",
      "short": "Luxuserlebnisse",
      "intro": "Private Yachten, Hubschrauberflüge und die exklusivsten Arten, einen Tag in der Stadt zu verbringen.",
      "meta": "Luxuserlebnisse in Dubai: private Yachtcharter, Hubschrauberflüge und exklusive Touren."
    },
    "adventure": {
      "title": "Abenteuer & Natur",
      "short": "Abenteuer & Natur",
      "intro": "Fallschirmspringen über der Palme, Heißluftballon im Morgengrauen, Ziplines und Wanderungen in Hatta.",
      "meta": "Abenteuer in Dubai: Fallschirmspringen, Heißluftballonfahrten, Ziplines, Dünenbuggys und Wandern in Hatta."
    },
    "downtown-dubai": {
      "title": "Downtown Dubai",
      "short": "Downtown",
      "intro": "Der Burj Khalifa, die Dubai Mall und die Wasserspiele — die belebtesten Quadratkilometer der Stadt.",
      "meta": "Erlebnisse in Downtown Dubai: Burj Khalifa, Dubai Mall, Dubai Fountain und Dubai Opera."
    },
    "dubai-marina": {
      "title": "Dubai Marina",
      "short": "Dubai Marina",
      "intro": "Ein von Türmen gesäumter Kanal: Dhau-Dinnerfahrten zwischen den Lichtern, Jetskis hinaus zur Palme und die Strandpromenade von JBR.",
      "meta": "Erlebnisse in der Dubai Marina: Dhau-Dinnerfahrten auf dem Kanal, Jetski-Touren zur Palme und zum Burj Al Arab, JBR-Strand und Stadttouren mit Halt hier.",
      "seoTitle": "Dubai Marina: Aktivitäten, Dhau-Dinner & Jetski",
      "heading": "Erlebnisse in der Dubai Marina",
      "guideTitle": "Dubai Marina: gut zu wissen",
      "guide": [
        {
          "h": "Die Marina und JBR",
          "p": [
            "Die Dubai Marina ist ein rund drei Kilometer langer Kanal, in die Küste gegraben und von Wohntürmen gesäumt, mit einer Promenade, dem Marina Walk, an beiden Ufern. Zur Seeseite liegt JBR — Jumeirah Beach Residence — mit einem öffentlichen Strand und The Walk, einer Meile aus Cafés und Geschäften am Fuß der Türme. Direkt vor der Küste liegt Bluewaters Island.",
            "Nach Einbruch der Dunkelheit ist sie das lebendigste Viertel des neuen Dubai, und das meiste, was Sie hier buchen können, findet auf dem Wasser statt."
          ]
        },
        {
          "h": "Dinnerfahrten auf dem Kanal",
          "p": [
            "Die Dhau-Fahrten der Marina sind Abendausflüge: rund zwei Stunden den Kanal entlang auf einer hölzernen Dhau oder einem modernen Glasdachboot, mit Buffet, Musik oder Show an Bord und den beleuchteten Türmen ringsum. Manche fahren aus dem Kanal hinaus und zeigen die Skyline vom Meer aus.",
            "Im Vergleich zu den Creek-Fahrten in der Altstadt ist die Marina die moderne Kulisse — Wolkenkratzer statt Souks. Viele Angebote enthalten den Hoteltransfer; was jeweils inbegriffen ist, von den Getränken bis zum Menü, steht im Angebot."
          ]
        },
        {
          "h": "Jetskis und mehr",
          "p": [
            "Jetski-Touren starten in der Marina und führen die Küste entlang zur Palme, zum Atlantis und zum Burj Al Arab — von 30 Minuten bis zu zwei Stunden, mit einem Guide auf einem zweiten Jetski und meist ohne Führerschein. Kombitouren verbinden eine Marina-Fahrt mit einer Stadttour oder einer Wüstensafari, und in JBR sorgt eine Indoor-Schwarzlicht-Minigolfanlage für einen Abend mit Kindern.",
            "Auch private Yachten legen meist in der Marina ab; sie haben eine eigene Seite, Yachten & Boote. Die Liste hier ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was kann man in der Dubai Marina unternehmen?",
          "a": "Eine Dinnerfahrt auf dem Kanal, eine Jetski-Tour zur Palme und zum Burj Al Arab, ein Abend auf dem Marina Walk oder The Walk in JBR und tagsüber der Strand von JBR."
        },
        {
          "q": "Wie lange dauert eine Dhau-Fahrt in der Dubai Marina?",
          "a": "Meist etwa zwei Stunden am Abend, mit Dinner an Bord. Ist die Abholung vom Hotel inbegriffen, kommt davor und danach Zeit hinzu."
        },
        {
          "q": "Dhau-Fahrt in der Marina oder auf dem Creek?",
          "a": "Die Marina bietet moderne Wolkenkratzer und eine belebtere Kulisse; der Creek in der Altstadt ist die traditionelle Variante, vorbei an den Souks und alten Handelsdhaus, und meist ruhiger. Auf beiden gibt es Dinner an Bord."
        },
        {
          "q": "Wie komme ich zur Dubai Marina?",
          "a": "Mit der Metro, mit der Dubai Tram, die durch die Marina und an JBR entlang fährt, oder mit dem Taxi. Viele Fahrten und Touren enthalten den Hoteltransfer."
        }
      ]
    },
    "palm-jumeirah": {
      "title": "Palm Jumeirah",
      "short": "Palm Jumeirah",
      "intro": "Die palmenförmige Insel vor Jumeirah: Aquaventure im Atlantis, der Blick vom Palm Tower und Jetskis und Helikopter rund um die Palmwedel.",
      "meta": "Erlebnisse auf Palm Jumeirah: Aquaventure-Tickets im Atlantis, die Aussichtsplattform The View at The Palm, Jetski-Touren und Helikopterflüge über die Insel.",
      "seoTitle": "Palm Jumeirah: Atlantis, The View & Aktivitäten",
      "heading": "Erlebnisse auf Palm Jumeirah",
      "guideTitle": "Palm Jumeirah: gut zu wissen",
      "guide": [
        {
          "h": "Die Insel",
          "p": [
            "Palm Jumeirah ist die künstliche Insel in Form einer Palme: ein Stamm, der ins Meer hinausläuft, sechzehn mit Villen bebaute Wedel und ringsum ein Halbmond, der die Wellen bricht. An der Spitze des Halbmonds steht das Atlantis The Palm, gleich daneben das Atlantis The Royal.",
            "Die Form erschließt sich erst von oben oder vom Wasser aus — und genau darum geht es bei den meisten Touren hier."
          ]
        },
        {
          "h": "Atlantis und Aquaventure",
          "p": [
            "Aquaventure, der Wasserpark des Atlantis, ist der größte Anziehungspunkt der Insel: Rutschen durch Haifischlagunen, ein langer Lazy River und ein eigener Strand — planen Sie einen ganzen Tag ein. Das Aquarium im Hotel und die Begegnungen mit Haien lassen sich auch einzeln buchen.",
            "Tickets gibt es mit oder ohne Hoteltransfer. Ohne nehmen Sie ein Taxi oder die Palm Monorail, die den Stamm entlang vom Festland bis zum Atlantis fährt."
          ]
        },
        {
          "h": "Von oben und vom Wasser",
          "p": [
            "The View at The Palm ist eine Aussichtsplattform im 52. Stock des Palm Tower, auf halber Höhe des Stamms und rund 240 Meter hoch — die ganze Palme liegt unter Ihnen. Helikopterflüge aus der Gegend des Atlantis führen über die Wedel, den Burj Al Arab und die Marina, die kürzesten in rund zwölf Minuten.",
            "Jetski-Touren umrunden den Halbmond am Atlantis und am Burj Al Arab vorbei, meist ab der benachbarten Marina. Bootsfahrten rund um die Insel finden Sie auf der Seite Yachten & Boote. Die Liste hier ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was kann man auf Palm Jumeirah unternehmen?",
          "a": "Einen Tag im Wasserpark Aquaventure im Atlantis verbringen, die Insel von The View at The Palm oder aus dem Helikopter sehen, mit dem Jetski um den Halbmond fahren oder das Aquarium im Atlantis besuchen."
        },
        {
          "q": "Wo hat man den besten Blick auf Palm Jumeirah?",
          "a": "Von oben. The View at The Palm im 52. Stock des Palm Tower zeigt die ganze Form der Insel; ein Helikopterflug bietet den Postkartenblick aus noch größerer Höhe."
        },
        {
          "q": "Wie viel Zeit braucht man für Aquaventure?",
          "a": "Einen ganzen Tag: Rutschen, Lazy River und Strand füllen leicht sechs Stunden und mehr. In den warmen Monaten kommen Sie am besten zur Öffnung — an den großen Rutschen bilden sich bis Mittag Schlangen."
        },
        {
          "q": "Wie komme ich nach Palm Jumeirah?",
          "a": "Mit dem Taxi oder mit der Palm Monorail, die den Stamm entlang vom Festland bis zum Atlantis fährt. Viele Tickets enthalten den Hoteltransfer."
        }
      ]
    },
    "old-dubai": {
      "title": "Altstadt & Creek",
      "short": "Altstadt",
      "intro": "Die Windtürme von Al Fahidi, Überfahrten mit der Abra und die Gold- und Gewürzsouks von Deira.",
      "meta": "Erlebnisse in der Altstadt von Dubai: Rundgänge und Stadttouren durch Al Fahidi und die Souks, Abra-Fahrten über den Creek und Dhau-Dinnerfahrten auf dem Creek.",
      "seoTitle": "Altstadt Dubai: Touren zu Creek, Souks & Al Fahidi",
      "heading": "Erlebnisse in der Altstadt von Dubai",
      "guideTitle": "Die Altstadt von Dubai: gut zu wissen",
      "guide": [
        {
          "h": "Beide Ufer des Creek",
          "p": [
            "Der Dubai Creek ist der Meeresarm, um den die Stadt gewachsen ist. Am Westufer liegt in Bur Dubai das Al-Fahidi-Viertel — Gassen mit restaurierten Häusern aus Korallenstein und Windtürmen, kleinen Museen und Galerien — und der Textilsouk; am anderen Ufer hat Deira den Gold- und den Gewürzsouk. Al Seef, eine im alten Stil neu gebaute Uferpromenade, zieht sich an der Seite von Bur Dubai entlang.",
            "Hier verbringen die Rundgänge und die meisten klassischen Stadttouren ihre Zeit, vor oder nach dem Burj Khalifa und den Stränden."
          ]
        },
        {
          "h": "Abras, Souks und Führungen",
          "p": [
            "Die Abra, ein kleines hölzernes Wassertaxi, überquert den Creek in wenigen Minuten und gehört zu fast jeder Tour hier. Geführte Rundgänge zeigen Al Fahidi, die Abra und die Souks in zwei bis vier Stunden, manche mit Kostproben emiratischer Küche; Halb- und Ganztagestouren ergänzen Fotostopps im neuen Dubai.",
            "Gehen Sie morgens oder am späten Nachmittag: Mittags gibt es in den Gassen wenig Schatten, und am Abend sind die Souks am lebendigsten. In den Souks ist Handeln üblich; in den Goldgeschäften bestimmt vor allem das Gewicht des Stücks den Preis."
          ]
        },
        {
          "h": "Dinnerfahrten auf dem Creek",
          "p": [
            "Die Dhau-Fahrten auf dem Creek sind die traditionelle Variante: rund zwei Stunden am Abend auf einer hölzernen Dhau, vorbei an den beleuchteten Souks und den alten Handelsbooten, mit Buffet und Show — oft einem Tanoura-Tänzer — an Bord. Sie sind meist ruhiger als die Fahrten in der Marina.",
            "Manche Kombitouren verbinden eine Altstadt-Tour über zwei oder mehr Tage mit einer Wüstensafari oder einer Creek-Fahrt. Die Liste ist nach Bewertungen von Reisenden sortiert."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was kann man in der Altstadt von Dubai unternehmen?",
          "a": "Durch das Al-Fahidi-Viertel spazieren, mit der Abra über den Creek fahren, durch den Gold- und den Gewürzsouk in Deira bummeln und den Tag mit einer Dinnerfahrt auf dem Creek beenden — auf eigene Faust ein ganzer Tag, mit Guide ein halber."
        },
        {
          "q": "Wo liegt die Altstadt von Dubai?",
          "a": "Rund um den Dubai Creek im Norden der Stadt: Bur Dubai am Westufer, Deira am Ostufer. Von Downtown sind es 20–30 Minuten mit dem Taxi, und beide Metrolinien fahren hin."
        },
        {
          "q": "Was sollte man in der Altstadt von Dubai tragen?",
          "a": "Leichte Kleidung, die Schultern und Knie bedeckt — Pflicht für den Besuch einer Moschee und respektvoll im alten Viertel und in den Souks. Dazu bequeme Schuhe: Die Touren sind überwiegend zu Fuß."
        },
        {
          "q": "Lohnt sich eine Dhau-Fahrt auf dem Dubai Creek?",
          "a": "Ja, wenn Sie die traditionelle Seite Dubais erleben möchten: hölzerne Dhaus, die beleuchteten Souks an den Ufern und ein ruhigerer Abend als in der Marina. Das Dinner ist meist ein Buffet mit arabischen und internationalen Gerichten."
        }
      ]
    },
    "seeAlso": "Siehe auch:",
    "faqTitle": "Häufige Fragen",
    "boats": {
      "seoTitle": "Yacht mieten Dubai: private Yacht- & Bootstouren",
      "heading": "Private Yacht- und Bootstouren in Dubai",
      "meta": "Yacht mieten in Dubai: private Bootstouren mit Kapitän ab der Dubai Marina, vorbei an JBR, Ain Dubai, Palm Jumeirah, Atlantis und Burj Al Arab – auch abends mit Dinner.",
      "guideTitle": "So finden Sie die passende Yachttour in Dubai",
      "guide": [
        {
          "h": "So funktioniert eine private Yachttour",
          "p": [
            "Eine private Yachttour in Dubai ist eine Charter auf Stundenbasis: Boot, Kapitän und Crew sind nur für Ihre Gruppe gebucht, andere Gäste sind nicht an Bord. Die meisten Touren dauern zwei bis vier Stunden; Halbtages- und Tagescharter eignen sich für Gruppen, die baden, sich sonnen und sich Zeit lassen möchten.",
            "Das Angebot zeigt, um welches Boot es sich handelt — Motorboot, Motoryacht oder Katamaran —, wie lange die Tour dauert und was an Bord inbegriffen ist. Gebucht wird auf der Seite unseres Partners, wo der Anbieter Uhrzeit und Details für Ihre Gruppe bestätigt."
          ]
        },
        {
          "h": "Die klassische Route ab der Dubai Marina",
          "p": [
            "Fast alle Touren starten in der Dubai Marina, einem der größten künstlich angelegten Yachthäfen der Welt, gesäumt von Wohntürmen. Von dort geht es vorbei an den Stränden und der Promenade von JBR und an Bluewaters Island mit dem Riesenrad Ain Dubai, dann entlang des äußeren Bogens der Palm Jumeirah bis zum Atlantis The Palm.",
            "Längere Touren fahren weiter nach Süden zum Burj Al Arab, dem segelförmigen Hotel auf seiner eigenen Insel vor dem Jumeirah Beach — das bekannteste Fotomotiv jeder Tour. Bei zwei Stunden endet die Route meist an der Palm; ab drei Stunden bleibt Zeit, vor Anker zu gehen und zu baden."
          ]
        },
        {
          "h": "Sonnenuntergang, Party oder Feier?",
          "p": [
            "Am beliebtesten sind Touren zum Sonnenuntergang und am Abend: Die Skyline färbt sich golden und beginnt zu leuchten, während das Boot in die Marina zurückkehrt. Tagsüber sind die Touren zum Baden, für einen Stopp an der Palm und für klare Sicht auf die Küste.",
            "Viele Anbieter haben Thementouren — Geburtstags- und Jubiläumsfahrten, Heiratsanträge, Yachtpartys mit Musik oder eine Abendfahrt mit Dinner oder BBQ an Bord. Extras wie Jetski, Catering oder Dekoration werden meist zusätzlich gebucht; prüfen Sie, was das Angebot umfasst.",
            "Die kühleren Monate, etwa Oktober bis April, sind die Hauptsaison auf dem Wasser. Im Sommer meiden Touren am frühen Morgen und am Abend die größte Hitze."
          ]
        }
      ],
      "faq": [
        {
          "q": "Was kostet es, eine Yacht in Dubai zu mieten?",
          "a": "Jedes Angebot zeigt einen Ab-Preis für die gesamte Tour; er hängt von der Größe des Boots, der Dauer und der Saison ab. Kleine Motorboote für zwei Stunden sind am günstigsten, große Motoryachten für einen ganzen Tag am teuersten. Den endgültigen Preis für Ihre Gruppe bestätigt der Anbieter bei der Buchung."
        },
        {
          "q": "Kann man in Dubai ein Boot ohne Führerschein mieten?",
          "a": "Ja – mit Kapitän. Alle Touren hier sind Charter mit Crew: Der Kapitän fährt, Sie brauchen keinen Bootsführerschein. Ein Boot selbst zu fahren erlaubt Dubai nur mit einem anerkannten Bootsführerschein; ohne ihn steuern Sie höchstens einen Jetski oder ein Jetcar auf einer geführten Tour."
        },
        {
          "q": "Wie lange sollte eine Yachttour in Dubai dauern?",
          "a": "Zwei Stunden reichen für die Marina, JBR, Ain Dubai und die Palm. Wählen Sie drei oder vier Stunden, um bis zum Burj Al Arab zu fahren und zum Baden zu ankern, und einen halben oder ganzen Tag für einen entspannten Tag auf See."
        },
        {
          "q": "Ist die Yacht nur für unsere Gruppe?",
          "a": "Ja. Es sind private Charter: Boot und Crew sind für Ihre Gruppe gebucht, ohne andere Gäste. Wie viele Personen ein Boot aufnimmt, steht im jeweiligen Angebot."
        },
        {
          "q": "Gibt es Yachttouren am Abend mit Dinner?",
          "a": "Ja. Abendfahrten starten meist kurz vor Sonnenuntergang und kehren mit der beleuchteten Skyline in die Marina zurück; manche schließen ein Abendessen oder ein BBQ an Bord ein. Bei anderen bestellen Sie das Catering dazu – was inklusive ist, steht im Angebot."
        },
        {
          "q": "Kann man während der Tour baden?",
          "a": "Bei vielen längeren Touren ankert das Boot nahe der Palm oder vor den Stränden zum Baden; das Angebot sagt, ob Baden vorgesehen ist. Denken Sie an Badesachen und Sonnenschutz."
        },
        {
          "q": "Wann ist die beste Zeit für eine Yachttour in Dubai?",
          "a": "Am späten Nachmittag bis zum Sonnenuntergang, wenn das Licht am weichsten ist und die Skyline auf dem Rückweg zu leuchten beginnt. Von Oktober bis April ist das Wetter den ganzen Tag angenehm; im Sommer sind Touren am Morgen und am Abend kühler."
        },
        {
          "q": "Wo starten Yachttouren in Dubai?",
          "a": "Die meisten in der Dubai Marina, manche in anderen Häfen an der Küste. Den genauen Treffpunkt bestätigt der Anbieter nach der Buchung."
        },
        {
          "q": "Und eine Bootstour auf dem Dubai Creek?",
          "a": "Die Yachten fahren an der Küste von der Marina zur Palm. Auf dem Creek im alten Dubai sind es die Dhaus – traditionelle Holzboote, oft mit Abendessen – und die Abras, die kleinen Wassertaxis zwischen Bur Dubai und Deira, für eine kurze Überfahrt zu den Souks. Sie finden sie unter „Dhau-Fahrten“."
        }
      ]
    },
    "tours": {
      "seoTitle": "Dubai Ausflüge & Touren: Safari, Bootsfahrt, Tickets",
      "heading": "Ausflüge & Touren in Dubai",
      "meta": "Alle Ausflüge in Dubai, nach Bewertungen sortiert: Wüstensafari, Stadtführung, Dhau- und Yachtfahrt, Burj-Khalifa-Tickets, Ballonfahrt und Abu Dhabi.",
      "guideTitle": "So finden Sie den passenden Ausflug in Dubai",
      "guide": [
        {
          "h": "Welche Touren es gibt",
          "p": [
            "Die Ausflüge in Dubai lassen sich in wenige Gruppen teilen. Eine Wüstensafari führt in die Dünen vor der Stadt — mit Dune Bashing, Kamelritt und Abendessen im Wüstencamp. Stadtführungen zeigen beide Seiten Dubais in wenigen Stunden: die Altstadt am Dubai Creek mit Souks und Abra-Booten und das neue Dubai mit Downtown, der Palme und der Marina. Mit Tickets für Sehenswürdigkeiten kommen Sie auf den Burj Khalifa, in den Dubai Frame, das Aquarium, Ski Dubai oder die Wasserparks, oft zu einem festen Zeitfenster.",
            "Auf dem Wasser gibt es Dhau-Fahrten mit Abendessen auf dem Creek und in der Marina, private Yachtfahrten und Wassersport wie Jetski, Parasailing und Flyboarding. Ballon- und Hubschrauberflüge zeigen Wüste und Skyline von oben, und Tagesausflüge führen über Dubai hinaus — meist nach Abu Dhabi zur Scheich-Zayid-Moschee, zum Louvre und in die Freizeitparks auf Yas Island."
          ]
        },
        {
          "h": "Ihre Tage in Dubai planen",
          "p": [
            "Planen Sie nach der Tageszeit. Der Morgen ist die kühlste Zeit für Spaziergänge und die Altstadt — und die einzige für Ballonfahrten, die bei Sonnenaufgang starten. Die Mittagszeit verbringen Sie am besten drinnen: auf einer Aussichtsplattform, im Museum, im Aquarium oder in einer Mall. Der späte Nachmittag gehört der Wüstensafari, der Abend den Dhau-Fahrten, Yachttouren im Sonnenuntergang und der beleuchteten Skyline.",
            "Für die Klassiker reichen drei bis vier Tage: ein Tag für Downtown und den Burj Khalifa, einer für das alte Dubai und die Souks, einer für die Wüste und ein Abend auf dem Wasser. Ein fünfter Tag lässt Zeit für Abu Dhabi oder einen Strandtag. Von Oktober bis April ist das Wetter für alles angenehm; im Sommer wählen Sie Touren am Morgen und Abend und klimatisierte Attraktionen."
          ]
        },
        {
          "h": "Gruppentour, privat oder ohne Anstehen?",
          "p": [
            "Gruppentouren sind der günstigste Weg, Stadt und Wüste zu sehen: Sie fahren mit anderen Reisenden im Fahrzeug oder auf dem Boot, mit Guide. Private Touren kosten mehr, richten sich aber nach Ihrem Zeitplan, mit Auto, Guide oder Boot nur für Ihre Gruppe — lohnend für Familien, Paare mit besonderem Anlass und alle mit vollem Programm.",
            "Bei Sehenswürdigkeiten lohnt der Blick auf die Leistungen: festes Zeitfenster oder freier Eintritt, welche Etagen oder Bereiche dazugehören und ob der Transfer vom Hotel im Preis enthalten ist. Viele Touren holen Sie im Zentrum von Dubai am Hotel ab; für entferntere Gegenden prüfen Sie das Abholgebiet im Angebot."
          ]
        },
        {
          "h": "So funktioniert diese Liste",
          "p": [
            "Hier finden Sie alle Touren und Erlebnisse, die wir in Dubai listen, nach Bewertungen sortiert: Eine Tour mit vielen guten Bewertungen steht vor einer, die nur von wenigen Gästen die Höchstnote bekam. Über das Suchfeld finden Sie einen Ort oder eine Aktivität beim Namen, in einer Kategorie eine kürzere Liste mit eigenem Ratgeber.",
            "Gebucht wird auf der Seite unseres Partners — Viator für Touren und Tickets, Click&Boat für Yachtfahrten —, wo Sie vor dem Bezahlen den aktuellen Preis, freie Termine und die Stornobedingungen sehen. Viele Erlebnisse lassen sich bis 24 Stunden vor Beginn kostenlos stornieren; online gebucht haben Sie den Platz sicher und können trotzdem kurzfristig umplanen."
          ]
        }
      ],
      "faq": [
        {
          "q": "Welche Ausflüge in Dubai sind die besten?",
          "a": "Am besten bewertet sind die abendliche Wüstensafari mit Barbecue, ein Burj-Khalifa-Ticket zum Sonnenuntergang, eine Dhau-Fahrt mit Abendessen, eine Führung durch das alte Dubai mit Abra-Fahrt über den Creek und eine private Yachtfahrt an der Palme und dem Burj Al Arab vorbei. Diese Liste zeigt die Touren mit den stärksten Bewertungen zuerst."
        },
        {
          "q": "Wie viele Tage brauche ich für Ausflüge in Dubai?",
          "a": "Drei bis vier Tage reichen für die wichtigsten Sehenswürdigkeiten: Downtown und Burj Khalifa, das alte Dubai mit den Souks, eine Wüstensafari und eine Bootsfahrt. Planen Sie einen weiteren Tag für Abu Dhabi, einen Freizeitpark oder eine Ballonfahrt ein."
        },
        {
          "q": "Ausflüge in Dubai online oder vor Ort buchen?",
          "a": "Vor Ort, an der Hotelrezeption oder bei Straßenverkäufern, gibt es dieselben Safaris und Bootsfahrten – nur ohne Vergleich und ohne Bewertungen anderer Gäste. Online sehen Sie Leistungen, Bewertungen und Stornobedingungen vorher, und viele Touren lassen sich bis 24 Stunden vor Beginn kostenlos stornieren. Kurzfristig buchen können Sie auch online, oft noch für den nächsten Tag."
        },
        {
          "q": "Welche Ausflüge eignen sich für Kreuzfahrer?",
          "a": "Kreuzfahrtschiffe – etwa von AIDA, Mein Schiff oder MSC – legen in Dubai meist am Port Rashid oder am Dubai Harbour an, oft mit einer Übernachtung im Hafen. Viele Touren holen Sie am Kreuzfahrtterminal ab; das steht im Angebot unter Treffpunkt und Abholung. Wählen Sie Touren, die sicher vor dem Ablegen enden: eine Stadtrundfahrt, ein Burj-Khalifa-Ticket oder die Abendsafari bei einer Übernachtung im Hafen."
        },
        {
          "q": "Dubai auf eigene Faust oder mit Tour?",
          "a": "Vieles geht gut auf eigene Faust: Mit Metro und Taxi kommen Sie bequem nach Downtown, zum Burj Khalifa, in die Dubai Mall und ins alte Dubai, wo Sie mit der Abra über den Creek zu den Souks fahren. Eine Tour braucht es für die Wüste, das Wasser und Ausflüge nach Abu Dhabi – und für Tickets mit festem Zeitfenster bucht man ohnehin vorab."
        },
        {
          "q": "Wie findet man günstige Ausflüge in Dubai?",
          "a": "Gruppentouren sind deutlich günstiger als private, Morgensafaris oft günstiger als Abendsafaris mit Dinner, und Kombi-Tickets sparen gegenüber Einzeltickets. Manches kostet fast nichts: die Abra-Fahrt über den Creek, ein Spaziergang durch die Souks oder die Wasserspiele der Dubai Fountain am Abend."
        },
        {
          "q": "Ist die Abholung vom Hotel inklusive?",
          "a": "Die meisten Wüstensafaris, Stadtführungen und Tagesausflüge holen Sie an Hotels im Zentrum von Dubai ab — etwa in Downtown, der Marina, JBR und Deira — und bringen Sie zurück. Tickets und Bootsfahrten meist nicht; was enthalten ist und welche Gegenden abgedeckt sind, steht im Angebot."
        },
        {
          "q": "Lieber private Tour oder Gruppentour?",
          "a": "Gruppentouren sind günstiger und gesellig. Eine private Tour lohnt den Aufpreis, wenn Sie mit Kindern reisen, Ihr eigenes Tempo wollen oder etwas feiern: Fahrzeug, Guide oder Boot sind nur für Ihre Gruppe da."
        },
        {
          "q": "Kann ich kurzfristig für heute oder morgen buchen?",
          "a": "Oft ja: Viele Safaris, Bootsfahrten und Tickets lassen sich am Vortag oder sogar am selben Tag buchen, solange Plätze frei sind. In der Hochsaison von November bis März sowie an Wochenenden und Feiertagen buchen Sie besser einige Tage im Voraus."
        },
        {
          "q": "Welche Ausflüge gibt es ab Dubai nach Abu Dhabi und Oman?",
          "a": "Abu Dhabi ist der klassische Tagesausflug: die Scheich-Zayid-Moschee, der Louvre Abu Dhabi und die Freizeitparks auf Yas Island, etwa anderthalb Stunden Fahrt entfernt. Nach Oman führen vereinzelt Bootstouren an der Küste von Musandam ab Dibba – dafür brauchen Sie Ihren Reisepass. Beides finden Sie unter „Abu Dhabi & Tagesausflüge“."
        },
        {
          "q": "Gibt es Touren auf Deutsch?",
          "a": "Nur wenige: Fast alle Touren werden auf Englisch geführt, deutschsprachige Guides sind in Dubai selten. Die Sprachen des Guides stehen auf der Seite der Tour unter „Treffpunkt & Abholung“. Für Tickets, Bootsfahrten und Safaris ist das selten ein Hindernis; bei einer Stadtführung lohnt eine private Tour, bei der Sie nach einem deutschsprachigen Guide fragen können."
        }
      ]
    },
    "guides": {
      "guideTitle": "Ihre Dubai-Reise planen",
      "guide": [
        {
          "h": "Beste Reisezeit für Dubai",
          "p": [
            "Die beste Reisezeit für Dubai ist von November bis März: Tage um die 25 °C, Abende kühl genug zum Essen im Freien, und die Saison, in der Lieblinge wie Global Village und der Miracle Garden geöffnet haben. Wüstensafaris, Dhau-Fahrten und Strandtage sind dann am angenehmsten.",
            "April und Oktober sind warme Übergangsmonate. Von Mai bis September steigt das Thermometer über 40 °C, der Tag verlagert sich nach drinnen — Malls, Wasserparks, Ski Dubai, Aquarium — und Hotels sind am günstigsten. Der Ramadan rückt jedes Jahr etwa elf Tage nach vorn: Attraktionen bleiben geöffnet, aber die Zeiten ändern sich, also vor der Buchung die Daten prüfen."
          ]
        },
        {
          "h": "Wie viele Tage braucht man?",
          "p": [
            "Drei Tage reichen für das Wichtigste: Downtown mit Burj Khalifa und Wasserspielen, das alte Dubai am Creek mit Abra-Fahrt und Souks sowie eine Wüstensafari. Mit fünf Tagen kommen Palm Jumeirah und Dubai Marina, ein Strandtag und ein Ausflug nach Abu Dhabi dazu.",
            "Eine Woche lässt Zeit für die Freizeitparks — Dubai Parks and Resorts oder Yas Island in Abu Dhabi —, eine Ballonfahrt über den Dünen oder einen Yachtausflug und ruhigere Tage. Unsere Reiseführer schlagen Tagespläne vor, die Sie übernehmen können."
          ]
        },
        {
          "h": "Unterwegs und Tipps vor Ort",
          "p": [
            "Die Metro verbindet Flughafen, Deira, Downtown, Al Barsha und Dubai Marina; bezahlt wird mit der Nol-Karte, die auch in Bussen und in der Marina-Tram gilt. Für alles andere sind Taxis und Fahrdienst-Apps unkompliziert. Wochenende ist Samstag und Sonntag, Freitagnachmittage sind voll.",
            "Am Strand und am Pool ist die Kleidung locker; in Malls, in der Altstadt und in Moscheen Schultern und Knie bedecken. Alkohol gibt es nur in lizenzierten Hotels, Bars und Restaurants. Der Dirham ist an den US-Dollar gekoppelt, Karten werden fast überall akzeptiert."
          ]
        },
        {
          "h": "So funktionieren unsere Dubai-Reiseführer",
          "p": [
            "Jeder Reiseführer beantwortet eine Planungsfrage — wann reisen, wohin mit Kindern, welche Wüstensafari — und verlinkt die Touren, Tickets und Events auf Dubai To-Do, damit Sie aktuelle Preise vergleichen und direkt buchen können. Wir überarbeiten die Reiseführer, wenn sich Angebot und Veranstaltungskalender ändern."
          ]
        }
      ],
      "faq": [
        {
          "q": "Welcher Monat ist der beste für Dubai?",
          "a": "November bis März: warm statt heiß, und die saisonalen Attraktionen haben geöffnet. Dezember und Januar sind am vollsten und teuersten; November, Februar und März sind ein guter Kompromiss."
        },
        {
          "q": "Wie viele Tage sollte man in Dubai bleiben?",
          "a": "Vier bis fünf Tage reichen für Downtown, das alte Dubai, eine Wüstensafari, Palme und Marina sowie einen Ausflug nach Abu Dhabi. Drei Tage decken die Highlights ab; eine Woche lässt Zeit für Freizeitparks und Strand."
        },
        {
          "q": "Ist Dubai sicher für Touristen?",
          "a": "Ja. Dubai hat eine sehr niedrige Kriminalitätsrate und ist auch allein oder mit Kindern einfach zu bereisen. Respektieren Sie die Gesetze: Trunkenheit in der Öffentlichkeit, Drogen und anstößiges Verhalten werden streng bestraft."
        },
        {
          "q": "Brauche ich ein Visum für Dubai?",
          "a": "Das hängt vom Pass ab: Viele Nationalitäten erhalten bei der Ankunft ein kostenloses Visum, andere müssen es vorher beantragen. Prüfen Sie vor der Reise die offiziellen Einreiseinformationen der VAE für Ihre Nationalität."
        },
        {
          "q": "Was sollte man in Dubai anziehen?",
          "a": "Leichte, atmungsaktive Kleidung. Badekleidung ist am Strand und am Pool in Ordnung; in Malls, in der Altstadt und in Moscheen Schultern und Knie bedecken — und eine Jacke für die starke Klimaanlage einpacken."
        }
      ]
    },
    "new-years-eve": {
      "title": "Silvester in Dubai",
      "intro": "Gala-Dinner, Beachclub-Partys, Konzerte und Bootsfahrten für die letzte Nacht des Jahres — und wo man das Feuerwerk am Burj Khalifa, an der Palme und in der Marina sieht.",
      "meta": "Silvester in Dubai: Partys, Gala-Dinner, Konzerte und Feuerwerk-Bootsfahrten, dazu die besten Plätze für das Burj-Khalifa-Feuerwerk, Straßensperren und die Metro.",
      "seoTitle": "Silvester in Dubai: Partys, Gala-Dinner & Feuerwerk",
      "heading": "Silvester in Dubai: Partys, Dinner und Feuerwerk",
      "eventsTitle": "Partys, Gala-Dinner & Konzerte",
      "eventsOff": "Die Partys und Gala-Dinner für das nächste Silvester gehen im Herbst in den Verkauf und erscheinen hier, sobald es so weit ist. Bis dahin gilt der Ratgeber unten.",
      "eventsOffLink": "Was jetzt in Dubai los ist",
      "toursTitle": "Silvester-Bootsfahrten",
      "toursMore": "Alle Yacht- & Bootstouren",
      "guideTitle": "Silvester in Dubai planen",
      "guide": [
        {
          "h": "Partys, Gala-Dinner und Konzerte",
          "p": [
            "Das meiste an Silvester in Dubai findet mit Ticket statt: Gala-Dinner in Hotels mit Menü und Band, Beachclubs mit internationalen DJs, Konzerte arabischer Stars und großer Namen, Countdown-Partys auf Dachterrassen. Viele sind so geplant, dass man um Mitternacht eines der offiziellen Feuerwerke sieht — prüfen Sie vor der Wahl, ob der Ort wirklich zum Burj Khalifa, zur Palme oder zum Meer hin liegt.",
            "Im Ticket ist meist ein Dinner oder ein Getränkepaket enthalten; der Preis steigt mit der Aussicht. Lokale mit Alkoholausschank haben eine Lizenz, und die meisten Partys sind erst ab 21 Jahren."
          ]
        },
        {
          "h": "Silvester auf dem Wasser",
          "p": [
            "Eine Bootsfahrt ist die entspannteste Art, das Feuerwerk zu sehen: kein Gedränge, keine gesperrten Straßen und ein sicherer Platz um Mitternacht. Dhaus auf dem Dubai Creek und in Business Bay fahren in Richtung Burj-Khalifa-Feuerwerk, Yachten aus der Dubai Marina hinaus an JBR vorbei zum Atlantis und zum Burj Al Arab.",
            "Silvesterfahrten dauern länger als eine normale Abendfahrt und legen lange vor Mitternacht ab — rechnen Sie mit dem ganzen Abend bis nach dem Feuerwerk auf dem Wasser. Private Yachten für Gruppen sind zuerst ausgebucht."
          ]
        },
        {
          "h": "Wo man das Feuerwerk sieht",
          "p": [
            "Die Show am Burj Khalifa in Downtown Dubai ist die, die die Welt sieht — Feuerwerk und Lichtshow am Turm; das Viertel füllt sich ab dem Nachmittag, und Teile davon sind kostenpflichtige Zuschauerbereiche. Feuerwerk gibt es auch anderswo: rund um Atlantis The Palm und die Palm Jumeirah, am Burj Al Arab, an JBR und Bluewaters, am Dubai Frame und im Global Village. Die offizielle Liste für die kommende Nacht wird im Dezember bekannt gegeben.",
            "Wer das Gedränge in Downtown meiden will, schaut vom Wasser aus zu: vom Dubai Water Canal, aus Business Bay, vom Strand an der JBR oder von einem Boot."
          ]
        },
        {
          "h": "Silvester mit Kindern",
          "p": [
            "Mitternacht in Downtown heißt langes Warten in einer dichten Menge — mit kleinen Kindern schwierig. Das Global Village hat in den letzten Jahren mehrere Countdowns über den Abend verteilt gefeiert, jeweils zur Mitternacht anderer Länder, sodass Familien Feuerwerk lange vor der Schlafenszeit sehen; eine Dinnerfahrt oder ein Hoteldinner mit Blick auf ein Feuerwerk ist die andere einfache Lösung.",
            "Es gibt familienfreundliche Gala-Dinner, viele Partys sind aber nur für Erwachsene — die Altersregel steht auf der Ticketseite."
          ]
        },
        {
          "h": "Straßensperren und Metro",
          "p": [
            "Die Straßen rund um den Burj Khalifa werden am 31. Dezember ab dem Nachmittag gesperrt, die Parkplätze in Downtown sind früh voll. Die Dubai Metro fährt meist die ganze Nacht, Stationen am Burj Khalifa können aber am Abend schließen, wenn das Viertel voll ist — eine Station früher aussteigen und laufen oder früh da sein.",
            "Taxis und Fahrdienste sind direkt nach Mitternacht knapp; bleiben Sie lieber noch eine Stunde, wo Sie sind, oder nehmen Sie die Metro."
          ]
        },
        {
          "h": "Wann buchen",
          "p": [
            "Die am besten gelegenen Gala-Dinner, Bootsfahrten und Partys sind in der ersten Dezemberhälfte ausverkauft, und die Preise steigen, je näher der Abend rückt. Buchen Sie möglichst im November — und lesen Sie die Stornobedingungen: Viele Silvestertickets sind nicht erstattbar."
          ]
        }
      ],
      "faq": [
        {
          "q": "Wo sieht man das Silvesterfeuerwerk in Dubai am besten?",
          "a": "Das Feuerwerk am Burj Khalifa in Downtown Dubai ist das größte, am besten zu sehen rund um die Dubai Mall, im Burj Park oder aus einem Restaurant mit Blick auf den Turm. Mit weniger Gedränge: vom Boot aus, aus Business Bay oder bei den Feuerwerken an der Palme, an der JBR oder im Global Village."
        },
        {
          "q": "Ist das Feuerwerk am Burj Khalifa kostenlos?",
          "a": "Von den öffentlichen Straßen und Promenaden in Downtown aus ja, aber sie sind Stunden vor Mitternacht voll und werden dann gesperrt. Einige Zuschauerbereiche am Turm waren in den letzten Jahren kostenpflichtig, ebenso Restaurants, Hotels und Bootsfahrten mit Aussicht."
        },
        {
          "q": "Wann sollte man an Silvester in Downtown Dubai sein?",
          "a": "Am Nachmittag oder frühen Abend: Die Straßen werden ab dem Nachmittag gesperrt, und der Zugang zum Viertel wird geschlossen, sobald es voll ist — oft lange vor Mitternacht."
        },
        {
          "q": "Fährt die Metro in Dubai an Silvester?",
          "a": "Meist ja, die ganze Nacht. Stationen direkt am Burj Khalifa können am Abend wegen des Andrangs schließen — planen Sie eine Nachbarstation ein."
        },
        {
          "q": "Kann man das Feuerwerk vom Boot aus sehen?",
          "a": "Ja — Dhaus und Yachten liegen um Mitternacht auf dem Wasser, die ruhigste Art, es zu sehen. Früh buchen: Silvesterfahrten sind schnell ausverkauft."
        },
        {
          "q": "Wann sollte man Silvester in Dubai buchen?",
          "a": "Bis November für die beste Auswahl; die beliebten Gala-Dinner, Partys und Bootsfahrten sind im Dezember ausverkauft, und die Preise steigen bis zum Abend."
        }
      ]
    },
    "hotels": {
      "title": "Wo übernachten",
      "seoTitle": "Wo übernachten in Dubai? Die besten Viertel & Hotelkarte",
      "heading": "Wo übernachten in Dubai?",
      "meta": "Wo übernachten in Dubai: Downtown, Business Bay, Dubai Marina, JBR, Palm Jumeirah, Jumeirah oder Alt-Dubai – für wen sich welches Viertel eignet, wie man hinkommt, und eine Hotelkarte mit Preisen für Ihre Reisedaten.",
      "intro": "Dubai ist lang und schmal: rund 40 km Küste vom Creek und der Altstadt bis zur Marina, dazwischen der Burj Khalifa. Wo Sie wohnen, entscheidet, ob Ihr Tag am Strand, in der Mall oder in der Metro beginnt. Hier steht, wie die Viertel sind – mit einer Karte ihrer Hotels und Preisen für Ihre Reisedaten von den großen Buchungsportalen.",
      "guideTitle": "Hotel in Dubai buchen",
      "guide": [
        {
          "h": "Strand oder Stadt?",
          "p": [
            "Wählen Sie ein Quartier für die ganze Reise, statt das Hotel zu wechseln. Die Strandviertel – Dubai Marina, JBR, Palm Jumeirah und Jumeirah – passen zu einem Urlaub am Meer; Downtown und Business Bay zum ersten Besuch mit Sehenswürdigkeiten, Malls und Fontäne; Alt-Dubai zu einem kleineren Budget und allen, die Souks und Creek erleben wollen.",
            "Downtown und die Marina liegen etwa 25 km auseinander: 30 bis 40 Minuten mit dem Taxi außerhalb der Stoßzeiten, etwas länger mit der roten Metrolinie, die beide auch mit dem Flughafen verbindet."
          ]
        },
        {
          "h": "Wann buchen?",
          "p": [
            "Von November bis März ist Hochsaison – warme Tage, milde Abende –, und um Weihnachten und Silvester sind die Preise am höchsten; die bestgelegenen Zimmer sind dann früh weg. Von Juni bis September ist es sehr heiß und am günstigsten; Resorts mit Pools und Beach Clubs lohnen sich dann besonders.",
            "Auch große Veranstaltungen füllen die Stadt: Messen, das Dubai Shopping Festival, das Formel-1-Wochenende in Abu Dhabi. Fallen Ihre Daten darauf, buchen Sie früh."
          ]
        },
        {
          "h": "Was im Preis steckt",
          "p": [
            "Hotels in Dubai erheben pro Zimmer und Nacht die Tourism-Dirham-Gebühr, zahlbar im Hotel; Buchungsportale weisen sie meist getrennt vom Zimmerpreis aus. Prüfen Sie, ob das Frühstück inklusive ist und ob Strand und Pools im Resort für Gäste kostenlos sind.",
            "Apartments sind in der Marina, in JBR und in Downtown verbreitet und lohnen sich für Familien und längere Aufenthalte: Küche, Waschmaschine, oft ein Pool im Haus."
          ]
        }
      ],
      "faq": [
        {
          "q": "Welches Viertel ist für den ersten Dubai-Besuch am besten?",
          "a": "Downtown Dubai: Burj Khalifa, Dubai Mall und Fontäne liegen vor der Tür, die Metro bringt Sie in die Altstadt und zur Marina, und die meisten Touren holen dort ab. Ist Ihnen der Strand wichtiger als die Sehenswürdigkeiten, wählen Sie Dubai Marina oder JBR."
        },
        {
          "q": "Wo übernachtet man in Dubai am Strand?",
          "a": "In JBR, wo die Hotels direkt am breiten öffentlichen Strand und an The Walk liegen, oder auf Palm Jumeirah, wo die meisten Resorts einen eigenen Strand haben. Jumeirah rund um den Burj Al Arab ist ruhiger, mit Resorts an langen Privatstränden."
        },
        {
          "q": "Welches Viertel eignet sich für Familien?",
          "a": "Palm Jumeirah und JBR: Strandresorts mit Kinderclubs und Pools, Aquaventure auf der Palme und eine ebene Strandpromenade in JBR. Für längere Aufenthalte ist ein Apartment in der Dubai Marina eine gute Alternative."
        },
        {
          "q": "Wo übernachtet man in Dubai günstig?",
          "a": "In Alt-Dubai – Deira und Bur Dubai – liegen die günstigsten Hotels, nah am Flughafen, an den Souks und an der Metro. Business Bay ist eine Mittelklasse-Option in Reichweite von Downtown."
        },
        {
          "q": "Wie kommt man zwischen den Vierteln hin und her?",
          "a": "Die rote Metrolinie fährt vom Flughafen über Deira, Bur Dubai, Downtown und Business Bay bis zur Marina; eine Straßenbahn verbindet Marina, JBR und die Monorail der Palme. Taxis und Fahrdienst-Apps gibt es überall."
        },
        {
          "q": "Verkaufen Sie Zimmer?",
          "a": "Nein. Die Karte und die Schaltflächen „Hotels ansehen“ zeigen Angebote der großen Buchungsportale über unseren Partner Stay22; Sie wählen, buchen und zahlen beim Buchungsportal zu dessen Bedingungen. Wir erhalten möglicherweise eine Provision, für Sie ohne Mehrkosten."
        }
      ]
    }
  },
  "tours": {
    "intro": "Alle Touren und Erlebnisse, die wir in Dubai listen — die bestbewerteten zuerst.",
    "searchLabel": "Touren durchsuchen",
    "resultsFor": "Ergebnisse für „{{query}}“",
    "noResults": "Nichts gefunden für „{{query}}“.",
    "clearSearch": "Suche zurücksetzen",
    "showMore_one": "Noch {{count}} anzeigen",
    "showMore_other": "Noch {{count}} anzeigen"
  },
  "boats": {
    "intro": "Private Yacht- und Bootstouren in Dubai: das Boot mit Crew nur für Ihre Gruppe, ab der Dubai Marina vorbei an der Palm, Atlantis und dem Burj Al Arab.",
    "typeLabel": {
      "Motorboat": "Motorboot",
      "Sailboat": "Segelboot",
      "Catamaran": "Katamaran",
      "RIB": "Schlauchboot (RIB)",
      "Motor yacht": "Motoryacht",
      "Houseboat": "Hausboot",
      "Boat without licence": "Führerscheinfreies Boot",
      "Jet ski": "Jetski",
      "Sailing yacht": "Segelyacht"
    },
    "fallbackTitle": "{{type}} {{name}} in Dubai mieten",
    "fallbackDescription": "{{type}} {{name}}, tageweise zu mieten in Dubai.",
    "perDay": "/ Tag"
  },
  "empty": {
    "title": "Demnächst",
    "text": "Wir gewinnen gerade die ersten Partner für diese Liste. Bis dahin ein paar Ideen für den Anfang."
  },
  "card": {
    "tour": "Touren & Erlebnisse",
    "boat": "Yachten & Kreuzfahrten",
    "from": "ab {{price}}",
    "reviews_one": "{{count}} Bewertung",
    "reviews_other": "{{count}} Bewertungen"
  },
  "tourFacts": {
    "includedTitle": "Leistungen",
    "included": "Inbegriffen",
    "excluded": "Nicht inbegriffen",
    "meetingTitle": "Treffpunkt & Abholung",
    "knowBeforeTitle": "Gut zu wissen",
    "private": "Private Tour — nur Ihre Gruppe nimmt teil",
    "shared_one": "Gruppentour, bis zu {{count}} Teilnehmer",
    "shared_other": "Gruppentour, bis zu {{count}} Teilnehmer",
    "languages": "Sprachen des Guides: {{languages}}",
    "pickupOptions": {
      "PICKUP_EVERYONE": "Abholung für alle Teilnehmer inbegriffen",
      "PICKUP_AND_MEET_AT_START_POINT": "Abholung möglich oder Treffen am Startpunkt",
      "MEET_EVERYONE_AT_START_POINT": "Treffen am Startpunkt (keine Abholung)"
    }
  },
  "detail": {
    "book": "Jetzt buchen",
    "bookBoat": "Jetzt buchen",
    "via": "über {{partner}}",
    "bookOn": "Sie buchen bei {{partner}}",
    "delisted": "Dieses Erlebnis ist nicht mehr verfügbar.",
    "delistedBoat": "Dieses Boot ist nicht mehr verfügbar.",
    "duration": "Dauer",
    "rating": "Bewertung",
    "price": "Preis",
    "year": "Baujahr",
    "more": "Weitere Erlebnisse"
  },
  "footer": {
    "sisterSites": "Unsere anderen Reiseführer:",
    "about": "Touren, Wüstensafaris, Yachtcharter und Erlebnisse in ganz Dubai.",
    "thingsToDo": "Erlebnisse",
    "areas": "Viertel",
    "language": "Sprache",
    "disclosure": "© dubai-todo.com · Ein unabhängiger Reiseführer. Einige Links sind Affiliate-Links: Wenn Sie über unsere Partner buchen, erhalten wir möglicherweise eine Provision — ohne Mehrkosten für Sie.",
    "tours": "Touren & Ausflüge"
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "text": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "home": "Zu Dubai To-Do"
  },
  "sample": {
    "dinner": {
      "category": "Touren & Erlebnisse",
      "title": "Dinner mit Aussicht",
      "text": "Dinner bei Sonnenuntergang mit unvergesslichem Blick über Dubai.",
      "place": "Downtown Dubai",
      "alt": "Terrassenrestaurant mit Blick auf die Skyline von Dubai in der Abenddämmerung"
    },
    "safari": {
      "category": "Wüstenerlebnisse",
      "title": "Luxus-Wüstensafari",
      "text": "Außergewöhnliche Abenteuer jenseits der Stadt.",
      "place": "Dubai Desert Conservation Reserve",
      "alt": "Geländewagen fährt bei Sonnenuntergang durch die Dünen"
    },
    "yacht": {
      "category": "Yachten & Kreuzfahrten",
      "title": "Private Yachtfahrt",
      "text": "Entlang der Küste Dubais segeln — in vollem Komfort.",
      "place": "Dubai Marina",
      "alt": "Motoryacht vor der Skyline von Dubai"
    }
  },
  "stub": {
    "saved": {
      "title": "Gemerkt",
      "intro": "Alle Erlebnisse, die Ihnen gefallen, an einem Ort.",
      "text": "Erlebnisse merken können Sie bald. Bis dahin ein paar Ideen für den Anfang."
    },
    "account": {
      "title": "Konto",
      "intro": "Ihr Dubai-To-Do-Konto.",
      "text": "Konten gibt es bald. Bis dahin ein paar Ideen für den Anfang."
    }
  },
  "events": {
    "metaTitle": "Events in Dubai — Brunch, Comedy, Konzerte & Nachtleben",
    "metaDescription": "Was ist los in Dubai: Brunches, Comedy-Abende, Konzerte, Beach Clubs und Familienshows — mit Terminen, Locations und Tickets.",
    "title": "Events in Dubai",
    "intro": "Brunches, Comedy-Abende, Konzerte, Beach-Club-Tage und Familienshows in Dubai in den nächsten Monaten — die beliebtesten zuerst.",
    "empty": "Unser Veranstaltungskalender für Dubai wird gerade gefüllt. Bis dahin ein paar Ideen für den Anfang.",
    "filters": {
      "when": "Wann",
      "category": "Art",
      "all": "Alle",
      "whens": {
        "any": "Alle Termine",
        "today": "Heute",
        "weekend": "Dieses Wochenende",
        "week": "Nächste 7 Tage",
        "month": "Nächste 30 Tage"
      },
      "loading": "Wird geladen…",
      "error": "Die Events konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "none": "Keine Events passen zu diesen Filtern.",
      "count_one": "{{count}} Event",
      "count_other": "{{count}} Events"
    },
    "card": {
      "dateMore_one": "{{date}} + {{count}} weiterer Termin",
      "dateMore_other": "{{date}} + {{count}} weitere Termine"
    },
    "detail": {
      "next": "Nächster Termin",
      "dates": "Termine",
      "dateCount_one": "{{count}} Termin",
      "dateCount_other": "{{count}} Termine",
      "venue": "Location",
      "tickets": "Tickets kaufen",
      "ended": "Dieses Event ist vorbei.",
      "upcoming": "Kommende Events ansehen",
      "highlights": "Highlights",
      "datesTitle": "Termine & Uhrzeiten",
      "soldOut": "ausverkauft",
      "moreDates_one": "und {{count}} weiterer Termin auf der Ticketseite.",
      "moreDates_other": "und {{count}} weitere Termine auf der Ticketseite.",
      "venueTitle": "Location",
      "map": "Karte",
      "faqTitle": "Gut zu wissen",
      "related": "Ähnliche Events",
      "allEvents": "Alle Events",
      "until": "Bis {{date}}"
    },
    "categories": {
      "gastronomy": "Brunch & Dinner",
      "parties": "Nachtleben",
      "concerts": "Konzerte & Musik",
      "theatre": "Comedy & Shows",
      "family": "Kinder & Familie",
      "sport": "Sport",
      "festivals": "Festivals",
      "exhibitions": "Ausstellungen & Kultur",
      "cinema": "Kino",
      "other": "Events"
    }
  },
  "guides": {
    "metaTitle": "Dubai-Reiseführer — Tipps, Routen & Aktivitäten",
    "metaDescription": "Dubai-Reiseführer: beste Reisezeit, Routen, Tipps für Familien, Wüstensafaris und was man buchen sollte — mit den Touren und Events von Dubai To-Do.",
    "title": "Dubai-Reiseführer",
    "intro": "Routen, Familientipps und praktische Ratschläge für Ihren Dubai-Urlaub — mit Links zu den Touren und Events, die wir erwähnen.",
    "empty": "Unsere ersten Reiseführer entstehen gerade. Bis dahin ein paar Ideen für den Anfang.",
    "badge": "Reiseführer",
    "more": "Weitere Dubai-Reiseführer",
    "all": "Alle Reiseführer",
    "readAlso": "Lesen Sie auch",
    "readingTime_one": "{{count}} Min. Lesezeit",
    "readingTime_other": "{{count}} Min. Lesezeit",
    "topics": {
      "desert": "Wüste & Safaris",
      "food": "Essen & Trinken",
      "seasonal": "Jahreszeiten",
      "boats": "Boote & Strände",
      "tours": "Touren & Ausflüge",
      "culture": "Kultur & Sehenswürdigkeiten",
      "shopping": "Shopping",
      "practical": "Praktische Tipps"
    }
  },
  "hotels": {
    "eventHeading": "Übernachtung gefällig?",
    "nearVenue": "Hotels in der Nähe von {{venue}}",
    "inCity": "Hotels in Dubai",
    "dates": "{{checkin}} → {{checkout}}",
    "cta": "Hotels ansehen",
    "ctaCity": "Hotels in Dubai ansehen",
    "showMap": "Hotels auf der Karte zeigen",
    "hideMap": "Karte ausblenden",
    "mapTitle": "Karte der Hotels in der Nähe",
    "sectionHeading": "Übernachten in Dubai",
    "sectionText": "Hotels, Apartments und Resorts in ganz Dubai – mit Preisen für Ihre Reisedaten von den großen Buchungsportalen.",
    "areasLink": "Welches Viertel passt?"
  },
  "hotelsPage": {
    "chipsLabel": "Viertel auf der Karte",
    "all": "Ganz Dubai",
    "mapText": "Hotels, Resorts und Apartments in ganz Dubai, mit Preisen für Ihre Reisedaten. Die Karte lädt von unserem Partner Stay22.",
    "openMap": "Hotelkarte anzeigen",
    "seeAll": "Hotels in Dubai ansehen",
    "areasTitle": "Dubais Viertel im Überblick",
    "bestFor": "Ideal für",
    "showOnMap": "Auf der Karte zeigen",
    "areas": {
      "downtown": {
        "name": "Downtown Dubai",
        "bestFor": "den ersten Besuch, Sehenswürdigkeiten, Shopping",
        "p": [
          "Burj Khalifa, Dubai Mall und Dubai Fountain bilden die Mitte von Downtown; die Hotels ringsum reichen von Fünf-Sterne-Türmen bis zu Apartments in den Wohnblocks. Abends ist viel los: die Wasserspiele, die Restaurants der Mall, der Souk Al Bahar.",
          "Die Metrostation Burj Khalifa / Dubai Mall liegt an der roten Linie, Altstadt und Marina sind also nur eine Fahrt entfernt. Was Downtown fehlt, ist ein Strand: Rechnen Sie 15 bis 20 Minuten mit dem Taxi nach Jumeirah."
        ],
        "cta": "Hotels in Downtown ansehen",
        "thingsToDo": "Erlebnisse in Downtown"
      },
      "business-bay": {
        "name": "Business Bay",
        "bestFor": "Downtown in Reichweite, günstiger",
        "p": [
          "Büro-, Hotel- und Apartmenttürme entlang des Dubai Water Canal, direkt neben Downtown: Viele Hotels liegen 10 bis 15 Gehminuten oder eine kurze Taxifahrt von der Dubai Mall entfernt, oft günstiger als Downtown selbst.",
          "Die Kanalpromenade ist abends angenehm, die Metrostation Business Bay liegt an der roten Linie. Manche Blöcke sind noch Baustelle – prüfen Sie, wo genau Ihr Hotel steht."
        ],
        "cta": "Hotels in Business Bay ansehen"
      },
      "dubai-marina": {
        "name": "Dubai Marina",
        "bestFor": "Restaurants, Nachtleben, das Meer in der Nähe",
        "p": [
          "Türme rund um einen Kanal voller Yachten, zu ihren Füßen die Cafés und Restaurants des Marina Walk, der Strand von JBR ein paar Straßen weiter. Viele Unterkünfte sind Apartments – gut für Familien und längere Reisen.",
          "Rote Metrolinie und Straßenbahn halten in der Marina; nach Downtown sind es 30 bis 40 Minuten. Yachtcharter und Dinner-Cruises legen direkt vor der Tür ab."
        ],
        "cta": "Hotels in der Dubai Marina ansehen",
        "thingsToDo": "Erlebnisse in der Dubai Marina"
      },
      "jbr": {
        "name": "JBR – Jumeirah Beach Residence",
        "bestFor": "den Strand, direkt vom Hotel aus",
        "p": [
          "Der Strandabschnitt neben der Marina: Hotels und Apartments blicken auf einen breiten öffentlichen Strand, dahinter die Geschäfte und Restaurants von The Walk, über die Brücke Bluewaters Island.",
          "Es ist der lebhafteste Strand der Stadt, am Wochenende voll. Die Straßenbahn verbindet JBR mit den Metrostationen der Marina."
        ],
        "cta": "Hotels in JBR ansehen"
      },
      "palm-jumeirah": {
        "name": "Palm Jumeirah",
        "bestFor": "Strandresorts, Familien, eine besondere Reise",
        "p": [
          "Die Insel in Palmenform ist Heimat vieler großer Resorts Dubais – Atlantis The Palm an der Spitze, Hotels mit Privatstrand an den Wedeln und am Halbmond. Viele haben Pools, Kinderclubs und so viele Restaurants, dass man den ganzen Tag bleiben kann.",
          "Dafür liegt die Palme abseits: Die Monorail fährt den Stamm hinunter zur Straßenbahn der Marina, ein Taxi nach Downtown braucht 25 bis 40 Minuten."
        ],
        "cta": "Hotels auf der Palme ansehen",
        "thingsToDo": "Erlebnisse auf Palm Jumeirah"
      },
      "jumeirah": {
        "name": "Jumeirah",
        "bestFor": "ruhige Resorts am Strand",
        "p": [
          "Die Küste zwischen Downtown und Marina: niedrige Villen, öffentliche Strände und einige der bekanntesten Resorts der Stadt rund um den Burj Al Arab und Madinat Jumeirah mit seinen Kanälen und dem Souk.",
          "Ruhig und grün, auf halbem Weg zwischen Sehenswürdigkeiten und Marina – doch am Strand fährt keine Metro, Sie nehmen also das Taxi."
        ],
        "cta": "Hotels in Jumeirah ansehen"
      },
      "old-dubai": {
        "name": "Alt-Dubai – Deira & Bur Dubai",
        "bestFor": "kleineres Budget, die Souks, den nahen Flughafen",
        "p": [
          "Die beiden Ufer des Dubai Creek, wo die Stadt begann: Gold- und Gewürzsouk in Deira, das historische Viertel Al Fahidi in Bur Dubai und dazwischen die Abras, die für ein paar Münzen übersetzen. Die Hotels sind die günstigsten Dubais, zum Flughafen sind es 10 bis 15 Minuten.",
          "Die Metro bedient beide Ufer; Downtown ist 15 bis 20 Minuten entfernt, die Strände weiter. Die Straßen sind belebt und traditionell statt glänzend – genau das ist der Reiz."
        ],
        "cta": "Hotels in Alt-Dubai ansehen",
        "thingsToDo": "Erlebnisse in Alt-Dubai"
      }
    }
  }
}
